{
  "common": {
    "loading": "جاري التحميل...",
    "authenticating": "جاري المصادقة...",
    "settingUpApp": "جاري إعداد التطبيق...",
    "preparingOffline": "جاري تحضير وضع عدم الاتصال",
    "error": "خطأ",
    "success": "نجاح",
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "close": "إغلاق",
    "back": "رجوع",
    "next": "التالي",
    "confirm": "تأكيد",
    "search": "بحث",
    "offlineLoginRequired": "أنت غير متصل. يرجى تسجيل الدخول عند الاتصال بالإنترنت لاستخدام هذه الصفحة.",
    "offlineRequiresConnection": "تتطلب هذه الميزة اتصالاً بالإنترنت",
    "filter": "تصفية",
    "export": "تصدير",
    "import": "استيراد",
    "download": "تحميل",
    "upload": "رفع",
    "view": "عرض",
    "details": "تفاصيل",
    "settings": "الإعدادات",
    "logout": "تسجيل الخروج",
    "login": "تسجيل الدخول",
    "register": "تسجيل",
    "yes": "نعم",
    "no": "لا",
    "ok": "موافق",
    "name": "الاسم",
    "description": "الوصف",
    "date": "التاريخ",
    "time": "الوقت",
    "status": "الحالة",
    "actions": "الإجراءات",
    "more": "المزيد",
    "optional": "(اختياري)",
    "saving": "جاري الحفظ...",
    "open": "فتح",
    "unknown": "غير معروف",
    "unknownError": "خطأ غير معروف",
    "roles": {
      "SUPERUSER": "مستخدم متميز",
      "ADMIN": "مسؤول",
      "SITE_MANAGER": "مدير الموقع",
      "CONTRACTOR": "مقاول",
      "VIEWER": "مشاهد",
      "USER": "مستخدم"
    },
    "editDefectDetails": "تحرير تفاصيل العيب",
    "editBoundingBox": "ضبط العلامة",
    "deleteDefect": "حذف العيب",
    "confirmDeleteDefect": "هل تريد حقاً حذف هذا العيب؟",
    "defectDeleted": "تم حذف العيب",
    "errorDeletingDefect": "خطأ في حذف العيب",
    "addManualDefect": "إضافة عيب",
    "editDefect": "تحرير العيب",
    "addManualDefectDescription": "إنشاء عيب جديد. يمكنك ضبط الموضع بعد ذلك.",
    "noManualDefectsYet": "لم يتم تسجيل أي عيوب بعد.",
    "editDefectDescription": "تحرير تفاصيل العيب.",
    "defectType": "نوع العيب",
    "severity": "الخطورة",
    "trade": "حرفة",
    "recommendation": "التوصية",
    "describeDefect": "صف العيب...",
    "recommendedActions": "الإجراءات الموصى بها...",
    "createDefect": "إنشاء عيب",
    "requiredField": "يرجى ملء جميع الحقول المطلوبة",
    "errorUpdatingDefect": "خطأ في تحديث العيب",
    "defectSuccessfullyUpdated": "تم تحديث العيب بنجاح",
    "errorCreatingDefect": "خطأ في إنشاء العيب",
    "defectSuccessfullyCreated": "تم إنشاء العيب بنجاح",
    "defectQueuedOffline": "تم حفظ العيب — ستتم المزامنة عند الاتصال",
    "pending": "قيد الانتظار",
    "errorSavingDefect": "خطأ في حفظ العيب",
    "creating": "جاري الإنشاء...",
    "updating": "جاري التحديث..."
  },
  "nav": {
    "home": "الرئيسية",
    "dashboard": "الإحصائيات",
    "detect": "صورة / تحليل ذكي",
    "history": "السجل",
    "projects": "المشاريع",
    "knowledgeBase": "قاعدة المعرفة",
    "contractors": "المقاولون",
    "tickets": "إشعار العيوب",
    "emailTemplates": "قوالب البريد الإلكتروني",
    "billing": "الفواتير",
    "admin": "الإدارة",
    "systemSettings": "إعدادات النظام",
    "profile": "الملف الشخصي",
    "details": "تفاصيل",
    "inspections": "الجولات التفقدية",
    "new": "جديد",
    "floorplan": "مخطط الطابق",
    "users": "المستخدمون",
    "manual": "نصائح ومساعدة",
    "board": "المهام"
  },
  "knowledgeBase": {
    "missing_insulation": {
      "title": "عزل مفقود",
      "description": "يمكن أن تؤدي الأنابيب أو القنوات التي لا تحتوي على عزل كافٍ إلى فقدان الطاقة ومشاكل التكثيف.",
      "solution1": {
        "caption": "عزل الصوف المعدني",
        "step1": "تنظيف وتجفيف السطح",
        "step2": "اختيار سمك العزل المناسب وفقًا لـ EnEV",
        "step3": "تركيب أغلفة أو حصائر العزل",
        "step4": "إغلاق المفاصل بشريط لاصق",
        "step5": "تركيب حاجز بخار إذا لزم الأمر",
        "step6": "تركيب غلاف للحماية"
      },
      "solution2": {
        "caption": "عزل المطاط",
        "step1": "التحقق من قطر الأنبوب ونطاق درجة الحرارة",
        "step2": "اختيار أنابيب مطاطية بالسمك المناسب",
        "step3": "قطع التماس الطولي ووضعه حول الأنبوب",
        "step4": "إغلاق باستخدام مادة لاصقة خاصة",
        "step5": "إغلاق الأطراف بإحكام",
        "step6": "تركيب حماية من الأشعة فوق البنفسجية للاستخدام الخارجي"
      },
      "normen": [
        "DIN 4108-10",
        "EnEV 2014",
        "DIN EN ISO 12241"
      ],
      "estimatedCost": {
        "min": 15,
        "max": 40,
        "unit": "€/م"
      },
      "preventionTip1": "تركيب العزل مباشرة أثناء التثبيت",
      "preventionTip2": "الفحص المنتظم بحثًا عن التلف",
      "preventionTip3": "توثيق سمك العزل"
    },
    "exposed_wire": {
      "title": "أسلاك مكشوفة",
      "description": "الأسلاك الكهربائية غير المحمية تشكل خطرًا كبيرًا على السلامة.",
      "solution1": {
        "caption": "تركيب قناة كابلات",
        "step1": "قطع التيار الكهربائي والتحقق",
        "step2": "اختيار قناة الكابلات المناسبة",
        "step3": "تحديد المسار والتثبيت",
        "step4": "وضع وتنظيم الكابلات",
        "step5": "إغلاق غطاء القناة",
        "step6": "تركيب ملصقات"
      },
      "solution2": {
        "caption": "توزيع تحت الجص",
        "step1": "إيقاف وتأمين الدائرة الكهربائية",
        "step2": "قطع الشقوق وفقًا لمعايير DIN",
        "step3": "تمديد الأنابيب الفارغة",
        "step4": "سحب الكابلات",
        "step5": "تغطية الشقوق بالجص",
        "step6": "فحص وتوثيق التوصيلات"
      },
      "normen": [
        "DIN VDE 0100",
        "DIN 18015",
        "VDE 0298-4"
      ],
      "estimatedCost": {
        "min": 20,
        "max": 80,
        "unit": "€/م"
      },
      "preventionTip1": "مراعاة توجيه الكابلات في مرحلة التخطيط",
      "preventionTip2": "تخطيط احتياطيات كافية",
      "preventionTip3": "إجراء فحوصات بصرية منتظمة"
    },
    "missing_grounding": {
      "title": "تأريض مفقود",
      "description": "يمكن أن تصبح أجزاء النظام المعدنية بدون تأريض خطرة في حالة تيارات الخطأ.",
      "solution1": {
        "caption": "إنشاء وصلة معادلة الجهد",
        "step1": "تحديد شريط التأريض الرئيسي",
        "step2": "تمديد موصل التأريض (بحد أدنى 6 ملم مربع نحاس)",
        "step3": "تركيب مشابك التأريض على الأنابيب",
        "step4": "إنشاء اتصال بشريط التأريض الرئيسي",
        "step5": "قياس مقاومة الانتقال (< 0.1 أوم)",
        "step6": "إنشاء وثائق"
      },
      "solution2": {
        "caption": "تعديل موصل الأساس",
        "step1": "حساب متطلبات التأريض وفقًا لـ DIN",
        "step2": "تمديد موصل حلقي حول المبنى",
        "step3": "عمق لا يقل عن 0.5 متر",
        "step4": "الاتصال بشريط التأريض الرئيسي",
        "step5": "قياس مقاومة التأريض",
        "step6": "إنشاء بروتوكول اختبار"
      },
      "normen": [
        "DIN VDE 0100-410",
        "DIN VDE 0100-540",
        "DIN 18014"
      ],
      "estimatedCost": {
        "min": 50,
        "max": 200,
        "unit": "€/توصيلة"
      },
      "preventionTip1": "إنشاء مفهوم التأريض قبل بدء البناء",
      "preventionTip2": "إشراك جميع الأجزاء المعدنية في التأريض",
      "preventionTip3": "الفحص السنوي لمقاومة التأريض"
    },
    "missing_labeling": {
      "title": "ملصقات مفقودة",
      "description": "الأسلاك والمكونات غير الموسومة تجعل الصيانة صعبة ويمكن أن تؤدي إلى سوء التشغيل.",
      "solution1": {
        "caption": "تسمية الأنابيب",
        "step1": "تحديد اتجاه التدفق والوسط",
        "step2": "اختيار رمز اللون وفقًا لـ DIN 2403",
        "step3": "تركيب أشرطة أو لوحات التسمية",
        "step4": "إضافة أسهم اتجاه التدفق",
        "step5": "إشعارات الخطر إذا لزم الأمر",
        "step6": "تحديث الوثائق"
      },
      "solution2": {
        "caption": "تسمية لوحة المفاتيح",
        "step1": "إنشاء خطة تسمية",
        "step2": "تحديد تسميات موحدة",
        "step3": "تركيب تسميات المحطات",
        "step4": "تركيب حاملات المخططات",
        "step5": "إدراج المخططات الحالية",
        "step6": "إضافة ملاحظات الصيانة"
      },
      "normen": [
        "DIN 2403",
        "DIN EN 60204-1",
        "ISO 14726"
      ],
      "estimatedCost": {
        "min": 5,
        "max": 20,
        "unit": "€/تسمية"
      },
      "preventionTip1": "التسمية فور التثبيت",
      "preventionTip2": "استخدام نظام تسمية موحد",
      "preventionTip3": "الحفاظ على خطة التسمية"
    },
    "debris": {
      "title": "تلوث/حطام بناء",
      "description": "يمكن أن يعيق تلوث موقع البناء سير العمل ويشكل مخاطر على السلامة.",
      "solution1": {
        "caption": "تنظيف أولي",
        "step1": "ارتداء معدات السلامة",
        "step2": "التخلص من الحطام الخشن في حاوية",
        "step3": "كنس أو شفط المناطق",
        "step4": "التخلص من المواد الخطرة بشكل منفصل",
        "step5": "توثيق التخلص من النفايات",
        "step6": "التأكد من تسليمها نظيفة"
      },
      "solution2": {
        "caption": "تنظيف دقيق",
        "step1": "اتخاذ تدابير الحماية من الغبار",
        "step2": "استخدام مكنسة صناعية",
        "step3": "مسح الأسطح الرطبة",
        "step4": "تنظيف أنظمة التهوية",
        "step5": "تنظيف النوافذ والأبواب",
        "step6": "إنشاء بروتوكول قبول"
      },
      "normen": [
        "VOB/C DIN 18299",
        "KrWG",
        "GefStoffV"
      ],
      "estimatedCost": {
        "min": 2,
        "max": 10,
        "unit": "€/م²"
      },
      "preventionTip1": "تخطيط تنظيف يومي أساسي",
      "preventionTip2": "توفير حاويات نفايات",
      "preventionTip3": "إنشاء خطة تنظيف"
    },
    "missing_edge_protection": {
      "title": "حماية الحواف مفقودة",
      "description": "الحواف الساقطة غير المؤمنة تشكل خطرًا كبيرًا للحوادث.",
      "solution1": {
        "caption": "تركيب حماية جانبية",
        "step1": "تحديد ارتفاع ومنطقة السقوط",
        "step2": "اختيار نظام حماية جانبي وفقًا لـ DIN EN 13374",
        "step3": "وضع الأعمدة بمسافة قصوى 2.5 متر",
        "step4": "تركيب الدرابزين على ارتفاع 1 متر",
        "step5": "تركيب العارضة الوسطى على ارتفاع 0.5 متر",
        "step6": "تركيب لوح الحافة بارتفاع لا يقل عن 15 سم"
      },
      "solution2": {
        "caption": "تركيب شبكات التقاط",
        "step1": "اختيار نوع الشبكة وفقًا لارتفاع السقوط",
        "step2": "التحقق من نقاط التثبيت",
        "step3": "الشبكات بمسافة لا تزيد عن 6 أمتار تحت حافة السقوط",
        "step4": "تداخل لا يقل عن 75 سم",
        "step5": "الفحص من قبل خبير",
        "step6": "تركيب لوحة الاختبار"
      },
      "normen": [
        "DIN EN 13374",
        "DGUV Regel 101-002",
        "ASR A2.1"
      ],
      "estimatedCost": {
        "min": 30,
        "max": 100,
        "unit": "€/ل.م"
      },
      "preventionTip1": "تأمين السقوط قبل بدء العمل",
      "preventionTip2": "فحص بصري أسبوعي",
      "preventionTip3": "توثيق الفحوصات"
    },
    "safety_hazard": {
      "title": "مخاطر السلامة العامة",
      "description": "مصادر خطر مختلفة تؤثر على سلامة العمل.",
      "solution1": {
        "caption": "تسييج منطقة الخطر",
        "step1": "إجراء تقييم المخاطر",
        "step2": "إقامة شريط عزل أو سياج بناء",
        "step3": "وضع لافتات تحذير",
        "step4": "الإضاءة إذا لزم الأمر",
        "step5": "إنشاء ضوابط وصول",
        "step6": "توثيق الإجراءات"
      },
      "solution2": {
        "caption": "تنفيذ تدابير الحماية",
        "step1": "تحديد متطلبات معدات الحماية الشخصية (PPE)",
        "step2": "إجراء التدريب",
        "step3": "تعيين مسؤول سلامة",
        "step4": "إنشاء خطة طوارئ",
        "step5": "توفير مواد الإسعافات الأولية",
        "step6": "جولات سلامة منتظمة"
      },
      "normen": [
        "ArbSchG",
        "BaustellV",
        "DGUV Vorschrift 1"
      ],
      "estimatedCost": {
        "min": 100,
        "max": 500,
        "unit": "€/إجراء"
      },
      "preventionTip1": "تقييم المخاطر قبل بدء العمل",
      "preventionTip2": "تدريب منتظم على السلامة",
      "preventionTip3": "إنشاء سلسلة إبلاغ عن المخاطر"
    }
  },
  "dashboard": {
    "title": "الإحصائيات",
    "welcome": "مرحبا بعودتك",
    "totalAnalyses": "إجمالي التحليلات",
    "defectsFound": "العيوب المكتشفة",
    "activeProjects": "المشاريع النشطة",
    "pendingTickets": "التذاكر المعلقة",
    "recentAnalyses": "التحليلات الأخيرة",
    "quickActions": "إجراءات سريعة",
    "startNewAnalysis": "بدء تحليل جديد",
    "viewAllProjects": "عرض جميع المشاريع",
    "stats": "الإحصائيات",
    "newAnalysis": "تحليل جديد",
    "analysesMonth": "التحليلات (الشهر)",
    "remaining": "متبقي",
    "critical": "حرج",
    "manageProjects": "إدارة المشاريع",
    "ticketsSent": "إشعارات العيوب",
    "resolved": "تم حلها",
    "showAll": "عرض الكل",
    "performAnalysisNow": "قم بالتحليل الآن!",
    "noAnalysesYet": "لا توجد تحليلات بعد",
    "startFirstAnalysis": "ابدأ أول تحليل بالذكاء الاصطناعي",
    "startFirstAnalysisButton": "ابدأ التحليل الأول",
    "usageOverview": "نظرة عامة على الاستخدام",
    "monthlyUsage": "الاستهلاك الشهري",
    "daysRemaining": "أيام متبقية",
    "recentTickets": "التذاكر الأخيرة",
    "all": "الكل",
    "noTickets": "لا توجد تذاكر",
    "statusOpen": "مفتوح",
    "statusInReview": "قيد المراجعة",
    "statusCompleted": "مكتمل",
    "adminOverview": "نظرة عامة للمسؤول",
    "users": "المستخدمون",
    "orgUsage": "استخدام المنظمة",
    "avgPerUser": "المتوسط لكل مستخدم",
    "activeUsers": "المستخدمون النشطون",
    "adminDashboard": "لوحة تحكم المسؤول",
    "errorLoading": "خطأ في التحميل",
    "dashboardDataError": "تعذر تحميل بيانات لوحة التحكم.",
    "retryButton": "إعادة المحاولة",
    "user": "المستخدم"
  },
  "detect": {
    "title": "كشف العيوب",
    "subtitle": "التقط صورة أو قم بتحميلها للتحليل بالذكاء الاصطناعي",
    "takePhoto": "التقاط صورة",
    "uploadPhoto": "تحميل صورة",
    "analyzing": "جاري التحليل...",
    "analyzingImage": "جاري تحليل الصورة...",
    "aiModelsWorking": "نماذج الذكاء الاصطناعي تعمل",
    "selectProject": "اختر مشروع",
    "location": "الموقع",
    "details": "التفاصيل",
    "startAnalysis": "بدء التحليل",
    "reanalyze": "إعادة التحليل",
    "results": "النتائج",
    "defectsDetected": "{count} عيوب مكتشفة",
    "noDefectsFound": "لم يتم العثور على عيوب",
    "confidence": "الثقة",
    "severity": "الخطورة",
    "saveAnalysis": "حفظ التحليل",
    "retake": "إعادة التقاط",
    "createFirstProject": "إنشاء أول مشروع",
    "createProjectDescription": "لبدء اكتشاف العيوب، يرجى إنشاء مشروع أولاً. سيتم ربط جميع التحليلات بهذا المشروع.",
    "projectNameLabel": "اسم المشروع *",
    "projectNamePlaceholder": "مثال: مجمع سكني جديد",
    "descriptionLabel": "الوصف (اختياري)",
    "descriptionPlaceholder": "وصف موجز للمشروع",
    "addressLabel": "العنوان (اختياري)",
    "addressPlaceholder": "عنوان المشروع",
    "goToProjects": "اذهب إلى المشاريع",
    "createProject": "إنشاء مشروع",
    "creating": "جاري الإنشاء...",
    "enterProjectName": "الرجاء إدخال اسم المشروع",
    "projectCreatedSuccess": "تم إنشاء المشروع بنجاح!",
    "projectCreationError": "خطأ في إنشاء المشروع",
    "imageLoadedFromHistory": "تم تحميل الصورة من السجل - جاهزة لإعادة التحليل",
    "imageQueuedOffline": "تمت إضافة الصورة إلى قائمة الانتظار",
    "imageQueuedOfflineDescription": "سيتم تحميل الصورة بمجرد اتصالك بالإنترنت مرة أخرى.",
    "queueError": "خطأ في الإضافة إلى قائمة الانتظار",
    "imageUploaded": "تم تحميل الصورة!",
    "readyToAnalyze": "جاهز للتحليل",
    "uploadFailed": "فشل التحميل",
    "unknownError": "خطأ غير معروف",
    "cameraAccessDenied": "تم رفض الوصول إلى الكاميرا",
    "photoTaken": "تم التقاط الصورة!",
    "selectImageFirst": "الرجاء تحديد صورة أولا!",
    "uploadImageFirst": "الرجاء تحميل صورة أولا!",
    "offlineRerunNotAvailable": "الوضع غير متصل: إعادة التحليل متاحة فقط عبر الإنترنت",
    "analysisQueued": "تم إضافة الصورة إلى قائمة الانتظار",
    "analysisQueuedDescription": "سيتم تحليلها تلقائيًا بمجرد اتصالك بالإنترنت مرة أخرى",
    "offlineSnagSaved": "تم حفظ العيب",
    "offlineSnagSavedDescription": "{count, plural, one {عيب واحد في قائمة الانتظار} other {# عيوب في قائمة الانتظار}} - سيتم الرفع عند الاتصال",
    "checkingConnection": "جارٍ التحقق من الاتصال…",
    "queuedBanner": "{count, plural, one {عيب واحد في قائمة الانتظار} other {# عيوب في قائمة الانتظار}} · سيتم تحليله عند عودة الاتصال",
    "queuedBannerDraining": "{count, plural, one {عيب واحد في قائمة الانتظار} other {# عيوب في قائمة الانتظار}} · تتم المعالجة الآن",
    "slowConnectionQueued": "في قائمة انتظار الرفع",
    "slowConnectionQueuedDescription": "الاتصال بطيء جداً — سيتم الرفع عند تحسن الاتصال",
    "slowConnectionDetected": "اتصال بطيء — سيتم وضع الرفع في قائمة الانتظار",
    "existingInspectionsOnly": "الفحوصات الحالية فقط متاحة",
    "analysisFailed": "فشل التحليل",
    "locationSaved": "تم حفظ الموقع",
    "defectIdNotFound": "لم يتم العثور على معرّف العيب. يرجى إعادة التحليل.",
    "boundingBoxUpdated": "تم تحديث مربع الإحاطة",
    "errorSaving": "خطأ في الحفظ",
    "updateFailed": "فشل التحديث",
    "defectRemoved": "تمت إزالة العيب",
    "releaseToRefresh": "حرر للتحديث",
    "pullToRefresh": "اسحب للتحديث",
    "loadingHistory": "جاري تحميل السجل...",
    "defectsLabel": "العيوب",
    "okLabel": "موافق",
    "unclearLabel": "غير واضح",
    "switchProject": "تبديل المشروع",
    "backToCamera": "التقط صورة جديدة",
    "uploadTab": "تحميل",
    "cameraTab": "كاميرا",
    "dropImageHere": "اسحب الصورة هنا",
    "releaseToUpload": "حرر للتحميل",
    "clickToSelect": "أو انقر للاختيار",
    "openCamera": "فتح الكاميرا",
    "apiKeyMissing": "مفتاح API مفقود",
    "apiKeyMissingContactAdmin": "لم يتم تهيئة الذكاء الاصطناعي. يرجى التواصل مع المسؤول.",
    "goToSettings": "اذهب إلى الإعدادات",
    "cancel": "إلغاء",
    "save": "حفظ",
    "zoomIn": "🔍 تكبير",
    "zoomOut": "🔍 تصغير",
    "editBoundingBox": "تعديل مربع الإحاطة",
    "removeDefect": "إزالة العيب",
    "locationPlaceholder": "موقع (اختياري)",
    "analysisDetailsPlaceholder": "تفاصيل التحليل (اختياري) - مثال: 'فحص أنابيب المياه'",
    "detectedDefects": "العيوب المكتشفة ({count})",
    "ticket": "تذكرة",
    "workSafety": "سلامة العمل ({count})",
    "otherDefects": "عيوب أخرى ({count})",
    "unknownDefect": "عيب غير معروف",
    "type": "النوع",
    "unknown": "غير معروف",
    "trade": "التخصص",
    "description": "الوصف",
    "requestDefectFix": "طلب إصلاح العيب",
    "addToInspection": "إضافة إلى الجولة",
    "manualCapture": "بدون تحليل بالذكاء الاصطناعي",
    "manualCaptureTooltip": "إضافة العيوب يدويًا بدون تحليل الذكاء الاصطناعي",
    "manualCaptureError": "خطأ في إنشاء التحليل اليدوي",
    "debugErrorOccurred": "تصحيح: حدث خطأ",
    "debugLogs": "سجلات التصحيح",
    "console": "وحدة التحكم ({count})",
    "lastError": "آخر خطأ",
    "noLogsAvailable": "لا تتوفر سجلات",
    "noErrorAvailable": "لا يوجد خطأ متاح",
    "copyAll": "نسخ الكل",
    "deleteAll": "حذف الكل",
    "allLogsCopied": "تم نسخ جميع السجلات!",
    "logsDeleted": "تم حذف السجلات",
    "detectionSettings": "إعدادات الكشف",
    "adjustDetectionParameters": "تعديل معلمات الكشف",
    "maxDetections": "الحد الأقصى للاكتشافات",
    "defectsToDetect": "العيوب المراد اكتشافها",
    "missingInsulation": "عزل مفقود",
    "missingLabeling": "ملصقات مفقودة",
    "missingGrounding": "تأريض مفقود",
    "missingEdgeProtection": "حماية الحواف مفقودة",
    "exposedWires": "أسلاك مكشوفة",
    "contamination": "تلوث",
    "safetyRisk": "خطر على السلامة",
    "scaffoldingDistance": "مسافة السقالات >30 سم",
    "liftOnScaffolding": "مصعد على السقالات",
    "otherDefectsLabel": "عيوب أخرى",
    "close": "إغلاق",
    "exportOptions": "خيارات التصدير",
    "downloadJSON": "تحميل بيانات JSON",
    "jsonDownloaded": "تم تحميل JSON بنجاح!",
    "downloadImageWithMarkers": "تحميل الصورة مع العلامات",
    "imageDownloaded": "تم تحميل الصورة بنجاح!",
    "uploadingImage": "جارٍ تحميل الصورة...",
    "imageUploadedShort": "تم تحميل الصورة!",
    "uploadFailedShort": "فشل التحميل",
    "offlineAnalysisQueued": "غير متصل: تم إضافة التحليل إلى قائمة الانتظار",
    "takePhotoTitle": "التقاط صورة",
    "takePhotoSubtitle": "ضع الكائن المراد تحليله",
    "cameraDone": "تم",
    "projectAndLocation": "المشروع والموقع",
    "currentProject": "المشروع الحالي",
    "projectLabel": "المشروع",
    "noProjectSelected": "لم يتم اختيار مشروع",
    "noActiveProject": "لا يوجد مشروع نشط",
    "assignHintPreparing": "جارٍ تجهيز الصورة…",
    "locationOptional": "الموقع (اختياري)",
    "analysisDetailsLabel": "تفاصيل التحليل (اختياري)",
    "analysisDetailsPlaceholderLong": "مثال: 'فحص أنابيب المياه في القبو' أو 'فحص التركيبات الكهربائية الطابق الثاني'",
    "analysisDetailsHelper": "سياق إضافي لتحليل الذكاء الاصطناعي",
    "analysisSettings": "إعدادات التحليل",
    "noDefectsToAssign": "لا توجد عيوب للتعيين",
    "addedToInspection": "تمت الإضافة إلى المعاينة",
    "assignError": "خطأ في التعيين",
    "zeroDefectsTitle": "لم يتم اكتشاف عيوب",
    "zeroDefectsDescription": "اكتمل التحليل بنجاح. لم يتم العثور على عيوب بناء في هذه الصورة.",
    "rerunAnalysis": "إعادة تشغيل التحليل",
    "startNewAnalysis": "بدء تحليل جديد",
    "goToHistory": "الذهاب إلى السجل",
    "burst": {
      "photosTaken": "{count} صور تم التقاطها",
      "analyzeAll": "تحليل الكل",
      "analyzeAllCount": "تحليل الكل {count}",
      "retry": "إعادة المحاولة",
      "saveManual": "حفظ بدون تحليل بالذكاء الاصطناعي",
      "viewResults": "عرض النتائج ({count} صور)",
      "analysesComplete": "{count} تحليلات مكتملة",
      "analysesFailed": "{failed} من {total} تحليلات فشلت — إعادة المحاولة",
      "photosSaved": "{count} صور محفوظة",
      "photoSaveFailed": "تعذر حفظ الصورة",
      "photosAdded": "{count} صور تم رفعها",
      "uploading": "جارٍ الرفع {current} / {total}",
      "uploadComplete": "{count} صور تم رفعها",
      "proceedQuestion": "كيف تريد المتابعة؟",
      "tapHint": "انقر للتحديد، وانقر مرة أخرى للتكبير",
      "detailsForPhoto": "تفاصيل الصورة {n}",
      "analyzeAllAi": "تحليل الكل بالذكاء الاصطناعي",
      "createRequest": "إنشاء طلب",
      "analyzingProgress": "جارٍ تحليل {count} صور…",
      "legendSelected": "محدد",
      "legendError": "خطأ",
      "legendDefects": "تم العثور على عيوب",
      "legendClean": "لا توجد عيوب"
    }
  },
  "history": {
    "title": "سجل التحليلات",
    "description": "نظرة عامة على تحليلات الذكاء الاصطناعي الخاصة بك",
    "loadingHistory": "جاري تحميل السجل...",
    "loadStuckHint": "مخزن البيانات المحلي لا يستجيب. يرجى إعادة تحميل التطبيق.",
    "reloadApp": "إعادة تحميل التطبيق",
    "noAnalyses": "لا توجد تحليلات",
    "filterByProject": "تصفية حسب المشروع",
    "filterByDate": "تصفية حسب التاريخ",
    "showAll": "عرض الكل",
    "viewDetails": "عرض التفاصيل",
    "deleteAnalysis": "حذف التحليل",
    "analysisDate": "تاريخ التحليل",
    "project": "المشروع",
    "defectsCount": "{count} عيوب",
    "defects": "العيوب",
    "created": "تم الإنشاء",
    "errorLoadingHistory": "خطأ في تحميل السجل",
    "confirmDelete": "هل تريد حقًا حذف هذا التحليل؟",
    "analysisDeleted": "تم حذف التحليل",
    "errorDeleting": "خطأ في الحذف",
    "imageUrlNotAvailable": "رابط الصورة غير متوفر",
    "errorLoadingImage": "خطأ في تحميل الصورة",
    "errorPreparingRerun": "خطأ في إعداد إعادة التشغيل",
    "analysisExported": "تم تصدير التحليل",
    "exportFailed": "فشل التصدير",
    "locationUpdated": "تم تحديث الموقع",
    "errorUpdatingLocation": "فشل تحديث الموقع",
    "projectUpdated": "تم تحديث المشروع",
    "errorUpdatingProject": "فشل تحديث المشروع",
    "searchPlaceholder": "بحث نصي حر",
    "releaseToRefresh": "حرر للتحديث",
    "pullToRefresh": "اسحب للتحديث",
    "analysesCount": "{count} تحليلات",
    "newAnalysis": "تحليل جديد",
    "filterAllAnalyses": "جميع التحليلات",
    "filterCompleted": "مكتمل",
    "filterError": "فشل",
    "filterAllProjects": "جميع المشاريع",
    "filterNoProject": "بدون مشروع",
    "filterDateRange": "الفترة",
    "filterDateReset": "إعادة تعيين",
    "filterDateApply": "تطبيق",
    "filterAllUsers": "جميع المستخدمين",
    "filterAllInspections": "جميع الجولات",
    "filterAllBuildings": "جميع المباني",
    "filterAllFloors": "جميع الطوابق",
    "filterAllRooms": "جميع الغرف",
    "noAnalysesFound": "لم يتم العثور على تحليلات",
    "tryOtherFilters": "جرب إعدادات تصفية أخرى",
    "offlineBanner": "غير متصل — يتم عرض البيانات المحفوظة",
    "offlineNoData": "لا توجد بيانات محفوظة",
    "offlineNoDataHint": "يرجى زيارة هذه الصفحة أولاً عبر الإنترنت حتى يتم تخزين البيانات.",
    "offlineNotAvailable": "غير متاح في وضع عدم الاتصال",
    "offlineNotAvailableHint": "لم يتم تخزين هذا التحليل في وضع عدم الاتصال. الرجاء الاتصال بالإنترنت.",
    "pendingShort": "قيد الانتظار",
    "performFirstAnalysis": "قم بإجراء أول تحليل لك لرؤيته هنا",
    "startNewAnalysis": "بدء تحليل جديد",
    "versionsCount": "{count} إصدارات",
    "unnamedAnalysis": "تحليل غير مسمى",
    "requestDefectFix": "طلب إصلاح العيب",
    "page": "صفحة",
    "of": "من",
    "entries": "مدخلات"
  },
  "projects": {
    "title": "المشاريع",
    "createNew": "مشروع جديد",
    "editProject": "تعديل المشروع",
    "deleteProject": "حذف المشروع",
    "projectName": "اسم المشروع",
    "projectDescription": "وصف المشروع",
    "address": "العنوان",
    "startDate": "تاريخ البدء",
    "endDate": "تاريخ الانتهاء",
    "teamMembers": "أعضاء الفريق",
    "addMember": "إضافة عضو",
    "noProjects": "لا توجد مشاريع",
    "analyses": "التحليلات",
    "analysis": "تحليل",
    "tickets": "التذاكر",
    "active": "نشط",
    "completed": "مكتمل",
    "description": "إدارة مشاريع البناء الخاصة بك",
    "loading": "جاري تحميل المشاريع...",
    "count": "{count} مشاريع",
    "searchPlaceholder": "البحث حسب اسم المشروع، الوصف أو العنوان...",
    "filterAll": "جميع المشاريع",
    "filterActive": "المشروع الافتراضي",
    "filterInactive": "مشاريع أخرى",
    "noProjectsFound": "لم يتم العثور على مشاريع",
    "noMatchingProjects": "لا توجد مشاريع مطابقة لبحثك",
    "createFirstProject": "أنشئ مشروعك الأول",
    "createFirstProjectButton": "إنشاء أول مشروع",
    "standard": "افتراضي",
    "defects": "العيوب",
    "created": "تم الإنشاء",
    "setAsStandard": "تعيين كافتراضي",
    "archiveProject": "أرشفة المشروع",
    "confirmArchive": "هل تريد حقًا أرشفة المشروع؟",
    "archived": "مؤرشف",
    "confirmDelete": "هل تريد حذف المشروع \"{name}\" نهائيًا؟ سيتم حذف جميع التحليلات والتفتيشات والعيوب والتذاكر والمخططات وأعضاء الفريق لهذا المشروع بشكل دائم. لا يمكن التراجع عن هذا الإجراء.",
    "page": "صفحة",
    "of": "من",
    "projectNameRequired": "اسم المشروع *",
    "projectNamePlaceholder": "مثال: مستشفى جامعة هايدلبرغ",
    "descriptionLabel": "الوصف",
    "descriptionPlaceholder": "وصف المشروع الاختياري",
    "addressLabel": "العنوان",
    "addressPlaceholder": "عنوان المشروع",
    "saving": "جاري الحفظ...",
    "creating": "جاري الإنشاء...",
    "backToProjects": "العودة إلى المشاريع",
    "projectNotFound": "لم يتم العثور على المشروع",
    "errorLoadingDetails": "خطأ في تحميل تفاصيل المشروع",
    "addMemberButton": "إضافة",
    "team": "الفريق",
    "offlineCache": "حفظ دون اتصال",
    "offlineCached": "محفوظ دون اتصال",
    "offlineCacheAdd": "إتاحة صور هذا المشروع دون اتصال على هذا الجهاز",
    "offlineCacheRemove": "التوقف عن حفظ صور هذا المشروع دون اتصال",
    "offlineCacheEnabled": "سيتم حفظ المشروع دون اتصال",
    "offlineCacheDisabled": "تم تعطيل الحفظ دون اتصال للمشروع",
    "offlineNotCached": "متصل فقط",
    "offlineNotCachedTooltip": "تفاصيل المشروع غير متاحة دون اتصال على هذا الجهاز",
    "open": "مفتوح",
    "closed": "تم الإنجاز",
    "recentAnalyses": "أحدث التحليلات",
    "viewAll": "عرض الكل",
    "noAnalysesYet": "لا توجد تحليلات بعد",
    "activeTickets": "التذاكر النشطة",
    "noActiveTickets": "لا توجد تذاكر نشطة",
    "statusCompleted": "مكتمل",
    "statusProcessing": "جاري المعالجة",
    "statusError": "خطأ",
    "statusOpen": "مفتوح",
    "statusInReview": "قيد المراجعة",
    "dueDate": "تاريخ الاستحقاق",
    "start": "بدء",
    "end": "انتهاء",
    "locationLabel": "الموقع (الإحداثيات)",
    "loadFromAddress": "تحميل الإحداثيات من العنوان",
    "latitude": "خط العرض",
    "longitude": "خط الطول",
    "locationLoaded": "تم تحميل الإحداثيات",
    "locationNotFound": "لم يتم العثور على إحداثيات لهذا العنوان",
    "loadingLocation": "جاري تحميل الإحداثيات...",
    "newButton": "جديد",
    "inspections": "الجولات التفقدية",
    "noInspectionsYet": "لا توجد جولات بعد",
    "inspectionStatusDraft": "مسودة",
    "inspectionStatusFinalized": "مكتمل",
    "inspectionStatusArchived": "مؤرشف"
  },
  "contractors": {
    "title": "المقاولون",
    "addNew": "مقاول جديد",
    "companyName": "اسم الشركة",
    "contactPerson": "الشخص المسؤول",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "trade": "التخصص",
    "noContractors": "لا يوجد مقاولون",
    "count": "{count} مقاول",
    "searchPlaceholder": "البحث عن طريق اسم الشركة، الشخص المسؤول، البريد الإلكتروني أو الهاتف...",
    "filterTrade": "تصفية التخصص",
    "allTrades": "جميع التخصصات",
    "noContractorsFound": "لم يتم العثور على مقاولين",
    "tryOtherFilters": "جرب إعدادات تصفية مختلفة",
    "createFirstContractor": "قم بإنشاء المقاول الأول الخاص بك",
    "createFirstContractorButton": "إنشاء أول مقاول",
    "projects": "المشاريع",
    "tickets": "التذاكر",
    "edit": "تعديل",
    "editContractor": "تعديل المقاول",
    "newContractor": "مقاول جديد",
    "companyNameRequired": "اسم الشركة *",
    "companyNamePlaceholder": "مثال: شركة الكهرباء المحدودة",
    "contactPersonRequired": "الشخص المسؤول *",
    "contactPersonPlaceholder": "مثال: أحمد محمد",
    "emailRequired": "البريد الإلكتروني *",
    "emailPlaceholder": "info@company.com",
    "phoneLabel": "الهاتف",
    "phonePlaceholder": "+966 123 456789",
    "tradeRequired": "التخصص *",
    "cancel": "إلغاء",
    "save": "حفظ",
    "create": "إنشاء",
    "contractorUpdated": "تم تحديث المقاول",
    "contractorCreated": "تم إنشاء المقاول",
    "errorSaving": "خطأ في الحفظ",
    "confirmDelete": "هل تريد حقًا حذف المقاول؟",
    "contractorDeleted": "تم حذف المقاول",
    "errorDeleting": "خطأ في الحذف",
    "paginationInfo": "صفحة {current} من {total} • {count} مقاول",
    "loading": "جاري تحميل المقاولين...",
    "trades": {
      "ELECTRICAL": "الكهرباء",
      "PLUMBING": "السباكة",
      "HVAC": "التدفئة/التهوية/تكييف الهواء",
      "DRYWALL": "الجبس",
      "SCAFFOLDING": "السقالات",
      "GENERAL": "عام"
    }
  },
  "tickets": {
    "title": "إشعارات العيوب",
    "createNew": "تذكرة جديدة",
    "sendTicket": "إرسال التذكرة",
    "ticketNumber": "رقم التذكرة",
    "assignedTo": "مخصص لـ",
    "dueDate": "الموعد النهائي",
    "priority": "الأولوية",
    "status": "الحالة",
    "open": "مفتوح",
    "inProgress": "قيد التنفيذ",
    "inReview": "قيد المراجعة",
    "completed": "مكتمل",
    "rejected": "مرفوض",
    "noTickets": "لا توجد تذاكر",
    "ticketsCount": "{count} تذاكر",
    "searchPlaceholder": "البحث عن طريق المقاول، المشروع، أو الملاحظات...",
    "searchingPlaceholder": "البحث في التذاكر...",
    "filterStatus": "تصفية حسب الحالة",
    "allStatuses": "جميع الحالات",
    "filterProject": "تصفية حسب المشروع",
    "allProjects": "جميع المشاريع",
    "filterContractor": "تصفية حسب المقاول",
    "allContractors": "جميع المقاولين",
    "noTicketsFound": "لم يتم العثور على تذاكر",
    "tryOtherFilters": "جرب إعدادات تصفية أخرى",
    "createFirstTicket": "أنشئ أول تذكرة عيب",
    "sent": "تم الإرسال",
    "project": "المشروع",
    "defectsCount": "{count} عيوب",
    "notes": "ملاحظات",
    "createdBy": "تم إنشاؤه بواسطة {name} في {date}",
    "send": "إرسال",
    "page": "صفحة",
    "of": "من",
    "entries": "مدخلات",
    "newTicket": "تذكرة عيب جديدة",
    "contractorRequired": "المقاول *",
    "selectContractor": "اختر مقاول",
    "projectOptional": "المشروع (اختياري)",
    "selectProject": "اختر مشروع",
    "noProject": "لا يوجد مشروع",
    "deadlineRequired": "الموعد النهائي *",
    "notesLabel": "ملاحظات",
    "notesPlaceholder": "ملاحظات إضافية حول إصلاح العيب...",
    "defectsCanBeAssigned": "يمكن تعيين العيوب من سجل التحليلات بعد الإنشاء.",
    "create": "إنشاء",
    "contractorAndDeadlineRequired": "المقاول والموعد النهائي مطلوبان",
    "ticketCreated": "تم إنشاء التذكرة",
    "errorCreating": "خطأ في الإنشاء",
    "statusUpdated": "تم تحديث الحالة",
    "errorUpdating": "خطأ في التحديث",
    "sendTicketByEmail": "إرسال التذكرة بالبريد الإلكتروني",
    "sendToContractor": "إرسال التذكرة إلى {contractor}",
    "emailTemplate": "قالب البريد الإلكتروني",
    "selectTemplate": "اختر قالب",
    "default": "(افتراضي)",
    "sendNow": "إرسال الآن",
    "emailSimulated": "البريد الإلكتروني محاكاة (مفتاح API مفقود)",
    "ticketSentSuccess": "تم إرسال التذكرة بالبريد الإلكتروني",
    "errorSending": "خطأ في الإرسال"
  },
  "ticketModal": {
    "title": "طلب إصلاح العيب",
    "requestTitle": "إنشاء طلب",
    "requestDescriptionLabel": "وصف الطلب",
    "requestDescriptionPlaceholder": "ماذا يجب على المقاول فعله؟ صف العمل المطلوب...",
    "selectContractor": "اختر مقاول",
    "selectContractorPlaceholder": "اختر مقاول...",
    "createNewContractor": "إنشاء مقاول جديد",
    "companyName": "اسم الشركة",
    "companyNamePlaceholder": "مثال: شركة الكهرباء المحدودة",
    "contactPerson": "الشخص المسؤول",
    "contactPersonPlaceholder": "مثال: أحمد محمد",
    "email": "البريد الإلكتروني",
    "emailPlaceholder": "info@company.com",
    "phone": "الهاتف",
    "phonePlaceholder": "+966 123 456789",
    "trade": "التخصص",
    "createContractor": "إنشاء مقاول",
    "errorCreating": "خطأ في الإنشاء",
    "pleaseSelectContractor": "الرجاء اختيار مقاول",
    "pleaseSelectDefect": "الرجاء اختيار عيب واحد على الأقل",
    "whichDefectsToForward": "ما هي العيوب التي يجب إرسالها؟",
    "confidence": "الثقة",
    "deadlineLabel": "الموعد النهائي للإصلاح",
    "deadlineDefault": "افتراضي: 7 أيام من اليوم",
    "additionalNotes": "ملاحظات إضافية (اختياري)",
    "notesPlaceholder": "معلومات إضافية للمقاول...",
    "emailPreview": "معاينة البريد الإلكتروني",
    "emailTo": "إلى",
    "emailSubject": "الموضوع",
    "emailSubjectText": "إصلاح العيب مطلوب{projectName, select, other { - {projectName}} }",
    "emailGreeting": "عزيزي/عزيزتي{contactPerson, select, other {, {contactPerson}} },",
    "emailIntroduction": "كجزء من مراقبة الجودة لدينا{projectName, select, other { في مشروع \"{projectName}\"} }، تم اكتشاف العيوب التالية، والتي نطلب منك معالجتها على الفور:",
    "location": "الموقع",
    "detectedDefects": "العيوب المكتشفة",
    "imageProof": "دليل الصورة مع العلامات",
    "markingsExplanation": "العلامات المرقمة تتوافق مع العيوب المذكورة أعلاه.",
    "deadlineToFix": "الموعد النهائي للإصلاح",
    "emailClosing1": "يرجى تأكيد استلام هذه الرسالة وإبلاغنا بتاريخ الإصلاح المخطط له.",
    "emailClosing2": "لا تتردد في الاتصال بنا إذا كان لديك أي أسئلة.",
    "emailBestRegards": "مع أطيب التحيات",
    "emailYourTeam": "فريق المشروع الخاص بك",
    "sending": "جاري الإرسال...",
    "sendNow": "إرسال الآن",
    "errorSending": "خطأ في الإرسال",
    "emailSimulated": "البريد الإلكتروني محاكاة (مفتاح API مفقود)",
    "requestSuccess": "تم طلب إصلاح العيب بنجاح!",
    "requestQueued": "سيتم إرسال الطلب عند تحسن الاتصال"
  },
  "defects": {
    "missing_insulation": "عزل مفقود",
    "exposed_wire": "أسلاك مكشوفة",
    "missing_grounding": "تأريض مفقود",
    "missing_labeling": "ملصقات مفقودة",
    "missing_edge_protection": "حماية الحواف مفقودة",
    "safety_hazard": "خطر على السلامة",
    "debris": "حطام البناء",
    "scaffolding_distance": "مسافة السقالات كبيرة جداً",
    "scaffolding_lift_placement": "وضع المصعد غير صحيح",
    "fire_hazard": "خطر حريق",
    "bitumen_point_load_damage": "ضرر حمولة نقطية على غشاء السقف",
    "cable_spacing_violation": "انتهاك مسافة الكابلات",
    "other": "عيوب أخرى"
  },
  "severity": {
    "low": "منخفض",
    "medium": "متوسط",
    "high": "مرتفع",
    "critical": "حرج"
  },
  "trades": {
    "heating": "التدفئة",
    "ventilation": "التهوية",
    "plumbing": "السباكة",
    "drywall": "الجبس",
    "electrical": "الكهرباء",
    "hvac": "التدفئة/التهوية/تكييف الهواء",
    "scaffolding": "السقالات",
    "general": "عام",
    "other": "أخرى"
  },
  "auth": {
    "login": "تسجيل الدخول",
    "logout": "تسجيل الخروج",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "forgotPassword": "نسيت كلمة المرور؟",
    "rememberMe": "تذكرني",
    "noAccount": "ليس لديك حساب؟",
    "signUp": "تسجيل",
    "invalidCredentials": "بيانات اعتماد غير صالحة",
    "loginSuccess": "تم تسجيل الدخول بنجاح",
    "logoutSuccess": "تم تسجيل الخروج بنجاح"
  },
  "errors": {
    "recovery": {
      "onlineTitle": "لا يمكن عرض هذه الصفحة الآن",
      "onlineAction": "إعادة التحميل",
      "offlineTitle": "هذه الصفحة غير متاحة دون اتصال",
      "offlineAction": "الذهاب إلى الصفحة الرئيسية",
      "boundaryHome": "الذهاب إلى الصفحة الرئيسية"
    },
    "generic": "حدث خطأ",
    "network": "خطأ في الشبكة",
    "unauthorized": "غير مصرح",
    "notFound": "غير موجود",
    "serverError": "خطأ في الخادم",
    "validationError": "خطأ في التحقق",
    "required": "هذا الحقل مطلوب",
    "invalidEmail": "عنوان بريد إلكتروني غير صالح",
    "passwordTooShort": "كلمة المرور قصيرة جداً",
    "contactSupport": "حدث خطأ. يرجى الاتصال بالدعم باستخدام معرّف الخطأ هذا.",
    "auth": {
      "unauthorized": "غير مصرح",
      "invalidCredentials": "بيانات اعتماد غير صالحة",
      "emailPasswordRequired": "البريد الإلكتروني وكلمة المرور مطلوبان",
      "userProfileNotFound": "لم يتم العثور على ملف تعريف المستخدم - يرجى الاتصال بالدعم",
      "profileNotFound": "لم يتم العثور على ملف تعريف المستخدم",
      "userCreationFailed": "فشل إنشاء المستخدم",
      "profileCreationFailed": "فشل إنشاء ملف تعريف المستخدم",
      "authenticationFailed": "فشلت المصادقة",
      "superuserRequired": "غير مسموح به: مطلوب دور مستخدم متميز (SUPERUSER)",
      "adminRequired": "غير مسموح به: مطلوب دور المسؤول (Admin)",
      "notProjectMember": "غير مسموح به: ليس عضوًا في المشروع",
      "notAuthorizedTicket": "غير مسموح به: غير مصرح بالوصول إلى هذه التذكرة",
      "noProjectAccess": "غير مسموح به: لا يوجد وصول لهذا المشروع",
      "noCompanyAccess": "غير مسموح به: لا يوجد وصول لهذه الشركة",
      "notResourceOwner": "غير مسموح به: أنت لا تملك هذا المورد",
      "sessionExpired": "انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى."
    },
    "validation": {
      "emailRequired": "البريد الإلكتروني مطلوب",
      "invalidRole": "دور غير صالح. يجب أن يكون مسؤول (ADMIN) أو مدير موقع (SITE_MANAGER)",
      "userIdRequired": "معرّف المستخدم مطلوب",
      "projectIdRequired": "معرّف المشروع مطلوب",
      "ticketIdRequired": "معرّف التذكرة مطلوب",
      "memberIdRequired": "معرّف العضو مطلوب",
      "analysisIdRequired": "معرّف التحليل مطلوب",
      "contractorIdRequired": "معرّف المقاول مطلوب",
      "deadlineRequired": "الموعد النهائي مطلوب",
      "missingFields": "الحقول المطلوبة مفقودة",
      "missingTemplateFields": "الحقول المطلوبة مفقودة: الاسم، الموضوع، نص HTML",
      "validRoleRequired": "مطلوب دور صالح (SITE_MANAGER, ADMIN)",
      "noValidDefects": "لم يتم اختيار عيوب صالحة",
      "userIdOrEmailRequired": "معرّف المستخدم أو البريد الإلكتروني مطلوب",
      "emailExists": "البريد الإلكتروني موجود بالفعل",
      "photoRequired": "مطلوب صورة واحدة على الأقل"
    },
    "users": {
      "emailExists": "مستخدم بهذا البريد الإلكتروني موجود بالفعل",
      "creationFailed": "فشل إنشاء المستخدم",
      "profileAutoCreationFailed": "فشل الإنشاء التلقائي لملف تعريف المستخدم",
      "notFound": "المستخدم غير موجود",
      "cannotDeleteSelf": "لا يمكنك حذف حسابك الخاص",
      "cannotDeleteSuperuser": "لا يمكن حذف حسابات المستخدم المتميز (Superuser)",
      "noAuthId": "المستخدم ليس لديه معرّف مصادقة - لا يمكن حذفه",
      "deleteFailed": "فشل حذف مصادقة المستخدم",
      "notFoundInAuth": "المستخدم غير موجود في نظام المصادقة",
      "notFoundByEmail": "لم يتم العثور على مستخدم بهذا البريد الإلكتروني",
      "inviteFailed": "فشل دعوة المستخدم",
      "updateFailed": "فشل تحديث المستخدم"
    },
    "projects": {
      "nameRequired": "اسم المشروع مطلوب",
      "notFound": "المشروع غير موجود",
      "creationFailed": "فشل إنشاء المشروع",
      "fetchFailed": "فشل جلب المشاريع",
      "updateFailed": "فشل تحديث المشروع",
      "deleteFailed": "فشل حذف المشروع",
      "setActiveFailed": "فشل تعيين المشروع النشط",
      "fetchCreatorFailed": "فشل جلب مُنشئ المشروع",
      "fetchTeamFailed": "فشل جلب أعضاء الفريق",
      "userIsCreator": "المستخدم هو بالفعل مُنشئ المشروع",
      "userAlreadyMember": "المستخدم هو بالفعل عضو في المشروع",
      "addUserFailed": "فشل إضافة المستخدم إلى المشروع",
      "addTeamMemberFailed": "فشل إضافة عضو الفريق",
      "teamMemberNotFound": "لم يتم العثور على عضو الفريق",
      "cannotRemoveCreator": "لا يمكن إزالة مُنشئ المشروع",
      "cannotRemoveSelf": "لا يمكنك إزالة نفسك من المشروع",
      "removeTeamMemberFailed": "فشل إزالة عضو الفريق",
      "cannotModifyCreator": "لا يمكن تعديل مُنشئ المشروع",
      "updateRoleFailed": "فشل تحديث دور المستخدم",
      "archiveFailed": "فشل أرشفة المشروع"
    },
    "tickets": {
      "fetchFailed": "فشل جلب التذاكر",
      "notFound": "التذكرة غير موجودة",
      "creationFailed": "فشل إنشاء التذكرة",
      "updateFailed": "فشل تحديث التذكرة",
      "sendFailed": "فشل إرسال التذكرة",
      "deleteFailed": "فشل حذف التذكرة",
      "notAvailableForSubmission": "التذكرة غير متاحة للإرسال",
      "notAvailableForCompletion": "التذكرة غير متاحة للإكمال"
    },
    "contractors": {
      "notFound": "المقاول غير موجود",
      "createFailed": "فشل إنشاء المقاول",
      "updateFailed": "فشل تحديث المقاول",
      "deleteFailed": "فشل حذف المقاول",
      "noEmail": "المقاول ليس لديه عنوان بريد إلكتروني"
    },
    "analyses": {
      "notFound": "التحليل غير موجود",
      "creationFailed": "فشل إنشاء التحليل",
      "loadFailed": "فشل تحميل التحليل",
      "saveFailed": "فشل حفظ التحليل"
    },
    "defects": {
      "fetchFailed": "فشل جلب العيوب",
      "noneFound": "لم يتم العثور على عيوب لهذا التحليل"
    },
    "emailTemplates": {
      "createFailed": "فشل إنشاء القالب",
      "updateFailed": "فشل تحديث القالب",
      "deleteFailed": "فشل حذف القالب",
      "notFound": "القالب غير موجود",
      "cannotDeleteDefault": "لا يمكن حذف القالب الافتراضي"
    },
    "upload": {
      "noFile": "لم يتم توفير ملف",
      "uploadFailed": "فشل الرفع",
      "failed": "فشل الرفع",
      "geminiFailed": "فشل رفع الذكاء الاصطناعي",
      "geminiNotUploaded": "لم يتم رفع الصورة إلى الذكاء الاصطناعي بعد",
      "geminiExpired": "انتهت صلاحية ملف الذكاء الاصطناعي - يرجى الرفع مرة أخرى",
      "completionPhotosFailed": "فشل رفع صور الإكمال"
    },
    "gemini": {
      "apiKeyMissing": "مفتاح API مفقود",
      "apiKeyNotConfigured": "لم يتم تكوين مفتاح API الذكاء الاصطناعي",
      "apiKeyNotConfiguredInSettings": "لم يتم تكوين مفتاح API الذكاء الاصطناعي في إعدادات النظام",
      "apiError": "خطأ API الذكاء الاصطناعي: {status} - {error}",
      "unexpectedResponse": "استجابة API غير متوقعة",
      "connectionError": "خطأ في الاتصال: {error}",
      "apiCallFailed": "فشل استدعاء API الذكاء الاصطناعي: {status} - {error}",
      "tokenLimitReached": "تم الوصول إلى حد رمز API الذكاء الاصطناعي - حاول تقليل المطالبة أو الحد الأقصى للعيوب",
      "safetyBlocked": "تم حظر استجابة API الذكاء الاصطناعي لأسباب تتعلق بالسلامة",
      "invalidResponseFormat": "تنسيق استجابة غير صالح من الذكاء الاصطناعي",
      "noValidResponse": "لا توجد استجابة صالحة من الذكاء الاصطناعي - تحقق من السجلات للحصول على التفاصيل",
      "invalidJsonResponse": "أرجع الذكاء الاصطناعي استجابة JSON غير صالحة: {error}",
      "parseAnalysisFailed": "فشل تحليل الذكاء الاصطناعي: {error}"
    },
    "storage": {
      "uploadAnalysisImageFailed": "فشل رفع صورة التحليل: {error}",
      "uploadCompletionPhotoFailed": "فشل رفع صورة الإكمال: {error}",
      "deleteImageFailed": "فشل حذف الصورة: {error}",
      "deleteImagesFailed": "فشل حذف الصور: {error}"
    },
    "email": {
      "sendFailed": "فشل إرسال البريد الإلكتروني إلى المقاول والمستلم البديل",
      "noRecipient": "لم يتم تحديد بريد إلكتروني للمستلم"
    },
    "rateLimit": {
      "exceeded": "تم تجاوز حد المعدل. حاول مرة أخرى في {seconds} ثانية.",
      "pleaseWait": "تم تجاوز حد المعدل. يرجى الانتظار {seconds} ثانية.",
      "emailExceeded": "تم إرسال عدد كبير جدًا من رسائل البريد الإلكتروني. يرجى المحاولة لاحقًا."
    },
    "service": {
      "temporarilyUnavailable": "الخدمة غير متاحة مؤقتًا.",
      "circuitBreakerOpen": "قاطع الدائرة مفتوح - خدمة الذكاء الاصطناعي تعاني من مشاكل"
    },
    "config": {
      "geminiKeyMissing": "لم يتم تكوين مفتاح API الذكاء الاصطناعي",
      "noPrompt": "لم يتم تكوين مطالبة في إعدادات النظام"
    },
    "permissions": {
      "cannotInvite": "أذونات غير كافية لدعوة المستخدمين",
      "adminOrManagerOnly": "غير مسموح به - للمسؤول أو مدير الموقع فقط",
      "adminOnly": "غير مسموح به - للمسؤول فقط",
      "cannotManageTeam": "يمكن لمنشئ المشروع والمسؤولين فقط إدارة الفريق"
    },
    "offlineQueue": {
      "uploadFailed": "فشل الرفع: {error}",
      "maxRetriesExceeded": "تم تجاوز الحد الأقصى لإعادة المحاولة"
    },
    "api": {
      "saveAnalysisFailed": "فشل حفظ التحليل",
      "fetchAnalysesFailed": "فشل جلب التحليلات",
      "loadAnalysisFailed": "فشل تحميل التحليل",
      "updateAnalysisFailed": "فشل تحديث التحليل",
      "deleteAnalysisFailed": "فشل حذف التحليل"
    },
    "preferences": {
      "fetchFailed": "فشل جلب التفضيلات",
      "saveFailed": "فشل حفظ التفضيلات",
      "notLoaded": "لم يتم تحميل أي تفضيلات"
    },
    "systemSettings": {
      "fetchFailed": "فشل جلب إعدادات النظام",
      "saveFailed": "فشل حفظ إعدادات النظام",
      "notLoaded": "لم يتم تحميل أي إعدادات نظام"
    },
    "dashboard": {
      "fetchProjectsFailed": "فشل جلب المشاريع",
      "fetchDataFailed": "فشل جلب بيانات لوحة التحكم",
      "fetchRecentAnalysesFailed": "فشل جلب التحليلات الأخيرة",
      "fetchUsageFailed": "فشل جلب بيانات الاستخدام"
    },
    "notifications": {
      "browserNotSupported": "متصفحك لا يدعم إشعارات الدفع."
    },
    "aiPricing": {
      "errorLoading": "خطأ في تحميل الأسعار",
      "errorUpdating": "خطأ في التحديث",
      "errorToggling": "خطأ في التبديل بين التفعيل/التعطيل"
    },
    "firebase": {
      "missingAdminConfig": "متغيرات بيئة Firebase Admin SDK مفقودة"
    },
    "imageHash": {
      "canvasContextFailed": "تعذر الحصول على سياق اللوحة"
    },
    "templates": {
      "notFound": "القالب غير موجود",
      "cannotDeleteDefault": "لا يمكن حذف القالب الافتراضي"
    },
    "knowledgeBase": {
      "notFound": "الحل غير موجود",
      "getFailed": "فشل جلب الحلول",
      "saveFailed": "فشل حفظ الحل",
      "deleteFailed": "فشل حذف الحل"
    },
    "canvas": {
      "legacyPathNotSupported": "لم تعد المسارات القديمة مدعومة - قم بتصحيح API",
      "fetchSignedImageFailed": "فشل جلب الصورة الموقعة: {status}"
    },
    "signedImage": {
      "legacyPathNotSupported": "لم تعد المسارات القديمة مدعومة - قم بتصحيح API",
      "fetchImageFailed": "فشل جلب الصورة: {status}"
    },
    "image": {
      "downloadFailed": "فشل تحميل الصورة من التخزين",
      "legacyPathNotSupported": "لم تعد المسارات القديمة مدعومة",
      "fetchFailed": "فشل تحميل الصورة (الحالة: {status})"
    },
    "analysis": {
      "aiFailed": "فشل تحليل الذكاء الاصطناعي",
      "geminiFailed": "فشل استشعار الذكاء الاصطناعي"
    },
    "timing": {
      "notStarted": "لم يبدأ التوقيت"
    },
    "alerts": {
      "cameraPermissionDenied": "تعذر فتح الكاميرا. يرجى التحقق من الإذن.",
      "exportFailed": "فشل التصدير. يرجى المحاولة مرة أخرى.",
      "linkCopied": "تم نسخ الرابط إلى الحافظة",
      "copyError": "خطأ في النسخ"
    }
  },
  "success": {
    "saved": "تم الحفظ بنجاح",
    "deleted": "تم الحذف بنجاح",
    "updated": "تم التحديث بنجاح",
    "created": "تم الإنشاء بنجاح",
    "sent": "تم الإرسال بنجاح",
    "users": {
      "createdWithDefaultPassword": "تم إنشاء المستخدم بنجاح بكلمة مرور افتراضية",
      "deleted": "تم حذف المستخدم {email} بنجاح",
      "teamMemberAdded": "تمت إضافة عضو الفريق بنجاح",
      "teamMemberRemoved": "تمت إزالة {name} من المشروع",
      "roleUpdated": "تم تحديث دور {name} إلى {role}"
    },
    "projects": {
      "created": "تم إنشاء المشروع",
      "updated": "تم تحديث المشروع",
      "archived": "تم أرشفة المشروع",
      "deleted": "تم حذف المشروع",
      "activeChanged": "تم تغيير المشروع الافتراضي",
      "userAdded": "تمت إضافة {name} إلى المشروع",
      "existingUserAdded": "تمت إضافة {name} إلى المشروع (مستخدم مصادقة موجود)",
      "userAddedWithFallback": "تمت إضافة {name} إلى المشروع بكلمة مرور افتراضية (فشل تسليم البريد الإلكتروني)",
      "userInvited": "تمت دعوة {name} إلى المشروع",
      "teamMemberAdded": "تمت إضافة عضو الفريق بنجاح",
      "teamMemberRemoved": "تمت إزالة {name} من المشروع",
      "roleUpdated": "تم تحديث دور {name} إلى {role}"
    },
    "tickets": {
      "createdAndSent": "تم إنشاء التذكرة وإرسال البريد الإلكتروني!",
      "createdWithFallback": "تم إنشاء التذكرة. فشل البريد الإلكتروني للمقاول، تم إرسال بريد إلكتروني احتياطي إلى {email}.",
      "photosUploaded": "تم رفع الصور بنجاح. في انتظار مراجعة مدير الموقع.",
      "submittedForReview": "تم تقديم التذكرة للمراجعة"
    },
    "gemini": {
      "connectionSuccessful": "تم الاتصال بنجاح! يعمل API الذكاء الاصطناعي."
    },
    "email": {
      "sent": "تم إرسال البريد الإلكتروني بنجاح",
      "simulated": "البريد الإلكتروني محاكاة (RESEND_API_KEY غير مُكوَّن)"
    },
    "defectSolutions": {
      "initialized": "تم تهيئة قاعدة بيانات حلول العيوب"
    },
    "systemSettings": {
      "saved": "تم حفظ الإعدادات"
    },
    "preferences": {
      "saved": "تم حفظ الإعدادات"
    },
    "aiPricing": {
      "priceActivated": "تم تفعيل السعر",
      "priceDeactivated": "تم إلغاء تفعيل السعر"
    },
    "notifications": {
      "enabled": "تم تفعيل الإشعارات"
    }
  },
  "info": {
    "email": {
      "simulated": "البريد الإلكتروني محاكاة (RESEND_API_KEY غير مُكوَّن)"
    },
    "tickets": {
      "createdButEmailFailed": "تم إنشاء التذكرة، ولكن فشل إرسال البريد الإلكتروني."
    }
  },
  "warnings": {
    "notifications": {
      "browserNotSupported": "هذا المتصفح لا يدعم الإشعارات",
      "pushNotSupported": "إشعارات الدفع غير مدعومة",
      "pushManagerNotAvailable": "مدير الدفع غير متاح"
    },
    "email": {
      "notConfigured": "البريد الإلكتروني غير مُكوَّن - سيتم تخطي الإشعار"
    },
    "timing": {
      "notStarted": "لم يبدأ التوقيت"
    }
  },
  "notifications": {
    "new": "إشعار جديد",
    "defectQueued": {
      "title": "ZeroSnag - التحليل في قائمة الانتظار",
      "body": "تمت إضافة اكتشاف العيب الخاص بك للمعالجة"
    },
    "defectProcessed": {
      "title": "ZeroSnag - اكتمل التحليل",
      "defectsFound": "تم اكتشاف {count} عيوب",
      "noDefects": "لم يتم العثور على عيوب - كل شيء على ما يرام!",
      "trades": "التخصصات: {trades}"
    },
    "offlineQueue": {
      "title": "ZeroSnag - تمت معالجة قائمة انتظار عدم الاتصال",
      "successWithFailures": "{successCount} ناجح، {failedCount} فاشل",
      "allSuccess": "تمت معالجة {successCount} تحليلات بنجاح"
    },
    "error": {
      "notSupported": "إشعارات الدفع غير مدعومة",
      "denied": "تم رفض الإشعارات",
      "activationFailed": "فشل تفعيل الإشعارات",
      "permissionDenied": "تم رفض الإذن - قم بتفعيله في إعدادات متصفحك"
    },
    "clickToEnable": "انقر على المفتاح لتفعيل الإشعارات",
    "disableInstructions": "لإلغاء تفعيل الإشعارات، يرجى الذهاب إلى إعدادات متصفحك.",
    "description": "احصل على إشعارات حول التحديثات الهامة، العيوب الجديدة وتغييرات المشروع."
  },
  "historyDetail": {
    "title": "تفاصيل التحليل",
    "backToHistory": "العودة إلى السجل",
    "backToInspection": "العودة إلى الجولة",
    "backToImage": "إلى الصورة",
    "addToInspection": "إضافة إلى الجولة",
    "analysisNotFound": "التحليل غير موجود",
    "analysisNotFoundDescription": "تعذر العثور على التحليل المطلوب.",
    "errorLoadingAnalysis": "خطأ في تحميل التحليل",
    "statusPending": "قيد الانتظار",
    "statusDefectsFound": "تم العثور على {count} عيوب",
    "statusNoDefects": "لا توجد عيوب",
    "manualAnalysis": "يدوي",
    "analysisFailed": "فشل التحليل — يرجى المحاولة مرة أخرى",
    "analysisFailedWithReason": "فشل التحليل — {reason}",
    "failureReason": {
      "apiKeyMissing": "الذكاء الاصطناعي غير مُهيأ",
      "imageUnavailable": "تعذر تحميل الصورة",
      "invalidImage": "الصورة تالفة أو غير قابلة للقراءة",
      "uploadFailed": "فشل الرفع",
      "analyzeFailed": "تعذر إكمال التحليل",
      "rateLimited": "الذكاء الاصطناعي مشغول، يرجى المحاولة لاحقًا",
      "tokenLimit": "التحليل كبير جدًا",
      "safetyBlocked": "حظر الذكاء الاصطناعي الرد",
      "timeout": "انتهت المهلة",
      "unknown": "خطأ غير معروف"
    },
    "analysisFailedRetry": "إعادة المحاولة",
    "cancel": "إلغاء",
    "save": "حفظ",
    "zoomIn": "🔍 تكبير",
    "zoomOut": "🔍 تصغير",
    "imageNotAvailable": "الصورة غير متاحة",
    "detectedDefects": "العيوب المكتشفة ({count})",
    "workSafety": "سلامة العمل ({count})",
    "otherDefects": "عيوب أخرى ({count})",
    "type": "النوع:",
    "confidence": "الثقة:",
    "severity": "الخطورة:",
    "trade": "التخصص:",
    "description": "الوصف:",
    "edit": "تعديل",
    "delete": "حذف",
    "confirmDelete": "هل تريد حقًا حذف هذا العيب؟",
    "defectDeleted": "تم حذف العيب",
    "errorDeleting": "خطأ في الحذف",
    "analysisInfo": "معلومات التحليل",
    "id": "المعرّف:",
    "created": "تم الإنشاء:",
    "status": "الحالة:",
    "statusCompleted": "مكتمل",
    "statusDefectsFoundShort": "تم العثور على عيوب",
    "analysisTime": "وقت التحليل:",
    "project": "المشروع:",
    "location": "الموقع:",
    "locationPlaceholder": "موقع (اختياري)",
    "locationSaved": "تم حفظ الموقع",
    "errorSavingLocation": "خطأ في حفظ الموقع",
    "noDefectsTitle": "لم يتم العثور على عيوب",
    "noDefectsDescription": "لم يكتشف تحليل الذكاء الاصطناعي أي عيوب في هذه الصورة.",
    "pendingAnalysisTitle": "التحليل قيد الانتظار",
    "pendingAnalysisDescription": "لم يتم إجراء هذا التحليل بعد.",
    "analyzeNow": "تحليل الآن",
    "reanalyze": "إعادة التحليل",
    "imageDataNotAvailable": "بيانات الصورة غير متاحة",
    "createdTickets": "التذاكر التي تم إنشاؤها",
    "createdTicketsCount": "التذاكر التي تم إنشاؤها ({count})",
    "createTicket": "إنشاء تذكرة",
    "defectNotification": "إشعار العيب",
    "statusOpen": "مفتوح",
    "statusInReview": "قيد المراجعة",
    "statusCompletedShort": "تم الإنجاز",
    "unknown": "غير معروف",
    "noDeadline": "لا يوجد موعد نهائي",
    "defectsCount": "{count} عيوب",
    "noTicketsYet": "لم يتم إنشاء تذاكر لهذا التحليل بعد",
    "noDefectsNoTickets": "لم يتم العثور على عيوب - لا توجد تذاكر مطلوبة",
    "createFirstTicket": "إنشاء أول تذكرة",
    "defectIdNotFound": "لم يتم العثور على معرّف العيب.",
    "updateFailed": "فشل التحديث",
    "boundingBoxUpdated": "تم تحديث مربع الإحاطة",
    "errorSaving": "خطأ في الحفظ",
    "prevAnalysis": "السابق",
    "nextAnalysis": "التالي",
    "toCamera": "إلى الكاميرا"
  },
  "ticketDetail": {
    "loading": "جاري تحميل التذكرة...",
    "notFound": "التذكرة غير موجودة",
    "notFoundDescription": "التذكرة المطلوبة غير موجودة أو تم حذفها.",
    "backToOverview": "العودة إلى النظرة العامة",
    "errorLoading": "خطأ في تحميل التذكرة",
    "errorUpdatingStatus": "تعذر تحديث الحالة",
    "errorUpdatingStatusMessage": "خطأ في تحديث الحالة",
    "statusUpdated": "تم تحديث الحالة بنجاح",
    "created": "تم الإنشاء",
    "sent": "تم الإرسال",
    "overdue": "⚠️ متأخر",
    "zoomOut": "🔍 تصغير",
    "zoom": "🔍 تكبير",
    "detectedDefects": "العيوب المكتشفة",
    "recommendation": "التوصية",
    "changeStatus": "تغيير الحالة",
    "statusOpen": "مفتوح",
    "statusInReview": "قيد المراجعة",
    "statusCompleted": "تم الإنجاز",
    "confirmCompletion": "تأكيد الإصلاح",
    "reject": "رفض",
    "deadline": "الموعد النهائي",
    "oclock": "ساعة",
    "contractor": "المقاول",
    "project": "المشروع",
    "createdBy": "تم إنشاؤه بواسطة",
    "completionDocumentation": "توثيق الإصلاح",
    "completion": "الإصلاح",
    "noPhotosUploaded": "لم يتم رفع أي صور",
    "contractorNotes": "ملاحظات من الحرفي:",
    "waitingForContractor": "في انتظار رد المقاول",
    "shareLink": "شارك هذا الرابط مع الحرفي لتوثيق الإصلاح",
    "scanQR": "مسح رمز الاستجابة السريعة",
    "directLink": "رابط مباشر",
    "directLinkInstructions": "انقر على الرابط أو أرسله بالبريد الإلكتروني/الواتساب إلى الحرفي:",
    "hint": "💡 تلميح:",
    "hintText": "يمكن للحرفي رفع صور الإصلاح وإضافة ملاحظات عبر هذا الرابط."
  },
  "projectTeam": {
    "title": "الفريق",
    "description": "إدارة أعضاء المشروع وإرسال الدعوات",
    "searchPlaceholder": "البحث في أعضاء الفريق...",
    "inviteMember": "دعوة عضو",
    "member": "عضو",
    "role": "الدور",
    "added": "تمت الإضافة",
    "analyses": "التحليلات",
    "tickets": "التذاكر",
    "creator": "المنشئ",
    "admin": "مسؤول",
    "siteManager": "مدير الموقع",
    "superuser": "مستخدم متميز",
    "errorLoading": "خطأ في التحميل",
    "errorLoadingMembers": "خطأ في تحميل أعضاء الفريق",
    "retryButton": "إعادة المحاولة",
    "noMembersFound": "لم يتم العثور على أعضاء الفريق",
    "noSearchResults": "لا يوجد أعضاء فريق مطابقين لبحثك",
    "inviteFirstMember": "ادعُ أول عضو في فريقك",
    "inviteFirstMemberButton": "دعوة أول عضو",
    "inviteMemberDialog": "دعوة عضو الفريق",
    "emailRequired": "البريد الإلكتروني مطلوب",
    "invitationSent": "تم إرسال الدعوة بنجاح!",
    "errorSendingInvitation": "خطأ في إرسال الدعوة",
    "invitedBy": "تمت الدعوة بواسطة {name}",
    "email": "البريد الإلكتروني",
    "name": "الاسم",
    "optional": "(اختياري)",
    "emailPlaceholder": "employee@company.com",
    "namePlaceholder": "مثال: أحمد علي",
    "info": "ℹ️ معلومة:",
    "infoText": "سيحصل عضو الفريق على دور \"مدير الموقع\" ويمكنه إنشاء تحليلات وإدارة التذاكر.",
    "cancel": "إلغاء",
    "sendInvitation": "إرسال الدعوة",
    "sending": "جاري الإرسال..."
  },
  "projectAnalyses": {
    "title": "التحليلات",
    "back": "رجوع",
    "errorLoading": "خطأ في تحميل التحليلات",
    "errorLoadingTitle": "خطأ في التحميل",
    "retryButton": "إعادة المحاولة",
    "pagination": "صفحة {page} من {pages} · الإجمالي: {total} تحليلات",
    "statusFilter": "تصفية حسب الحالة",
    "allStatuses": "جميع الحالات",
    "statusCompleted": "مكتمل",
    "statusProcessing": "جاري المعالجة",
    "statusFailed": "فشل",
    "showingRange": "عرض {from} إلى {to} من {total}",
    "previous": "السابق",
    "next": "التالي",
    "imageAlt": "تحليل",
    "defectsCount": "{count} عيوب",
    "noAnalysesFound": "لم يتم العثور على تحليلات",
    "noAnalysesYet": "لا توجد تحليلات بعد"
  },
  "projectTickets": {
    "title": "إشعارات العيوب",
    "back": "رجوع",
    "errorLoading": "خطأ في تحميل التذاكر",
    "errorLoadingTitle": "خطأ في التحميل",
    "retryButton": "إعادة المحاولة",
    "pagination": "صفحة {page} من {pages} · الإجمالي: {total} تذاكر",
    "statusFilter": "تصفية حسب الحالة",
    "allStatuses": "جميع الحالات",
    "statusOpen": "مفتوح",
    "statusInReview": "قيد المراجعة",
    "statusCompleted": "تم الإنجاز",
    "newTicket": "تذكرة جديدة",
    "showingRange": "عرض {from} إلى {to} من {total}",
    "previous": "السابق",
    "next": "التالي",
    "defectsCount": "{count} عيوب",
    "createdAgo": "تم الإنشاء {time}",
    "dueDate": "الموعد النهائي: {date}",
    "overdue": "متأخر",
    "noTicketsFound": "لم يتم العثور على تذاكر",
    "noTicketsYet": "لا توجد تذاكر بعد"
  },
  "adminDashboard": {
    "title": "لوحة تحكم المسؤول",
    "usersCount": "{count} مستخدم",
    "loadingUsers": "جاري تحميل المستخدمين...",
    "addUser": "إضافة مستخدم",
    "searchPlaceholder": "البحث عن طريق البريد الإلكتروني أو اسم المستخدم...",
    "filterAll": "جميع المستخدمين",
    "filterActive": "الاشتراكات النشطة",
    "filterOverLimit": "تم تجاوز الحد",
    "statsActiveUsers": "المستخدمون النشطون",
    "statsTotalAnalyses": "إجمالي التحليلات",
    "statsOverLimit": "تم تجاوز الحد",
    "statsPeriod": "الفترة الزمنية",
    "quickActions": "إجراءات سريعة",
    "manageUsers": "إدارة المستخدمين",
    "contractors": "المقاولون",
    "emailTemplates": "قوالب البريد الإلكتروني",
    "settings": "الإعدادات",
    "userUsage": "استخدام المستخدم",
    "noUsersFound": "لم يتم العثور على مستخدمين",
    "tryOtherFilters": "جرب إعدادات تصفية أخرى",
    "noDataAvailable": "لا تتوفر بيانات استخدام لهذا الشهر",
    "limitBadge": "الحد",
    "until": "حتى:",
    "ofAnalyses": "/ {limit} تحليلات",
    "percentUsed": "% مستخدم",
    "paginationInfo": "صفحة {current} من {total} • {count} مستخدم",
    "accessDenied": "تم رفض الوصول",
    "accessDeniedMessage": "هذه الصفحة متاحة للمسؤولين فقط.",
    "goHome": "الذهاب إلى الصفحة الرئيسية"
  },
  "adminUsers": {
    "title": "إدارة المستخدمين",
    "description": "إدارة المستخدمين وإرسال الدعوات",
    "searchPlaceholder": "البحث في المستخدمين...",
    "inviteUser": "دعوة مستخدم",
    "tableHeaderUser": "المستخدم",
    "tableHeaderRole": "الدور",
    "tableHeaderCreated": "تم الإنشاء",
    "tableHeaderActions": "الإجراءات",
    "editUser": "تعديل المستخدم",
    "deleteUser": "حذف المستخدم",
    "noUsersFound": "لم يتم العثور على مستخدمين",
    "noSearchResults": "لا يوجد مستخدمون مطابقون لبحثك",
    "inviteFirstUser": "ادعُ أول مستخدم لك",
    "inviteFirstUserButton": "دعوة المستخدم الأول",
    "inviteDialogTitle": "دعوة مستخدم",
    "emailRequired": "البريد الإلكتروني *",
    "emailPlaceholder": "user@company.com",
    "roleRequired": "الدور *",
    "nameOptional": "الاسم",
    "nameOptionalLabel": "(اختياري)",
    "namePlaceholder": "مثال: أحمد علي",
    "infoLabel": "ℹ️ معلومة:",
    "infoText": "سيتلقى المستخدم بريدًا إلكترونيًا يحتوي على رابط لتعيين كلمة المرور الخاصة به وإكمال ملفه الشخصي.",
    "cancel": "إلغاء",
    "sendInvitation": "إرسال الدعوة",
    "sending": "جاري الإرسال...",
    "emailRequiredError": "البريد الإلكتروني مطلوب",
    "invitationSent": "تم إرسال الدعوة بنجاح!",
    "invitationError": "خطأ في إرسال الدعوة",
    "roleAdmin": "مسؤول",
    "roleSiteManager": "مدير الموقع",
    "editModalTitle": "تعديل المستخدم",
    "featureInDevelopment": "الميزة قيد التطوير",
    "editFeatureComingSoon": "سيكون تعديل المستخدم متاحًا قريبًا.",
    "selectedUser": "المستخدم المختار:",
    "close": "إغلاق",
    "deleteModalTitle": "حذف المستخدم",
    "deleteConfirmation": "حذف المستخدم بشكل لا رجعة فيه؟",
    "deleteWarning": "لا يمكن التراجع عن هذا الإجراء. سيتم إزالة المستخدم بالكامل من النظام.",
    "userLabel": "المستخدم:",
    "roleLabel": "الدور:",
    "emailLabel": "البريد الإلكتروني:",
    "deleteButton": "حذف نهائي",
    "deleting": "جاري الحذف...",
    "userDeleted": "تم حذف المستخدم {email}",
    "deleteError": "خطأ في حذف المستخدم",
    "csvRoleHint": "الصيغة: البريد، الاسم، الدور — الدور اختياري (افتراضي: مدير الموقع). الخيارات: Bauleiter أو Admin.",
    "csvImport": "استيراد CSV",
    "csvTitle": "استيراد المستخدمين",
    "csvDownloadTemplate": "تحميل النموذج",
    "csvUploadFile": "رفع ملف CSV",
    "csvDragDrop": "اسحب ملف CSV هنا أو انقر للاختيار",
    "csvOrPaste": "أو الصق النص:",
    "csvPastePlaceholder": "البريد;الاسم;الدور\nmax@company.com;Max Mustermann;SITE_MANAGER",
    "csvParsePreview": "تحميل المعاينة",
    "csvPreview": "معاينة ({count} مستخدمين)",
    "csvHeaderEmail": "البريد الإلكتروني",
    "csvHeaderName": "الاسم",
    "csvHeaderRole": "الدور",
    "csvHeaderStatus": "الحالة",
    "csvValid": "صالح",
    "csvInvalidEmail": "بريد إلكتروني غير صالح",
    "csvInvalidRole": "دور غير صالح (ADMIN أو SITE_MANAGER)",
    "csvDuplicate": "مكرر في CSV",
    "csvNoValidEntries": "لم يتم العثور على إدخالات صالحة",
    "csvImportButton": "استيراد ({count} مستخدمين)",
    "csvImporting": "جاري الاستيراد...",
    "csvCancel": "إلغاء",
    "csvSuccess": "تم إنشاء {succeeded} من {total} مستخدمين",
    "csvError": "فشل الاستيراد",
    "csvResultCreated": "تم الإنشاء",
    "csvResultEmailFailed": "تم الإنشاء (فشل إرسال البريد!)",
    "csvFileLoaded": "تم تحميل CSV ({count} سطر)",
    "csvAllValid": "جميع الإدخالات صالحة",
    "csvHasErrors": "{count} إدخالات بها أخطاء"
  },
  "emailTemplates": {
    "title": "قوالب البريد الإلكتروني",
    "description": "إدارة قوالب إشعارات العيوب الخاصة بك",
    "newTemplate": "قالب جديد",
    "searchPlaceholder": "البحث في القوالب...",
    "availableVariables": "المتغيرات المتاحة:",
    "noTemplatesFound": "لم يتم العثور على قوالب",
    "noSearchResults": "لا توجد قوالب مطابقة لبحثك",
    "createFirstTemplate": "أنشئ أول قالب لك",
    "createFirstTemplateButton": "إنشاء أول قالب",
    "standard": "افتراضي",
    "subject": "الموضوع:",
    "createdBy": "تم إنشاؤه بواسطة {name} في {date}",
    "editTemplate": "تعديل القالب",
    "deleteTemplate": "حذف القالب",
    "newTemplateTitle": "قالب جديد",
    "editTemplateTitle": "تعديل القالب",
    "nameRequired": "الاسم *",
    "namePlaceholder": "مثال: إشعار العيب القياسي",
    "setAsDefault": "تعيين كافتراضي",
    "subjectRequired": "الموضوع *",
    "subjectPlaceholder": "مثال: إشعار العيب - {{projektName}} - الموعد النهائي: {{frist}}",
    "htmlEditor": "محرر HTML",
    "preview": "معاينة",
    "htmlContentPlaceholder": "محتوى HTML للبريد الإلكتروني",
    "cancel": "إلغاء",
    "save": "حفظ",
    "create": "إنشاء",
    "templateUpdated": "تم تحديث القالب",
    "templateCreated": "تم إنشاء القالب",
    "saveError": "خطأ في الحفظ",
    "deleteConfirmation": "هل تريد حقًا حذف القالب؟",
    "templateDeleted": "تم حذف القالب",
    "deleteError": "خطأ في الحذف",
    "comingSoonTitle": "الميزة قادمة قريبًا",
    "comingSoonMessage": "إنشاء القوالب قيد التطوير وسيكون متاحًا قريبًا.",
    "understood": "فهمت",
    "defaultTemplate": {
      "subject": "إشعار العيب",
      "greeting": "عزيزي/عزيزتي {{ansprechpartner}}،",
      "intro": "في المشروع <strong>{{projektName}}</strong>، تم اكتشاف <strong>{{anzahlMaengel}}</strong> عيوب يجب إصلاحها بحلول <strong>{{frist}}</strong>.",
      "hintsLabel": "ملاحظات:",
      "contact": "يرجى التواصل معنا إذا كان لديك أي أسئلة.",
      "signature": "مع أطيب التحيات،<br>فريق ZeroSnag الخاص بك",
      "footer": "تم إنشاء هذا البريد الإلكتروني تلقائيًا بواسطة ZeroSnag.",
      "exampleProject": "مثال مشروع هايدلبرغ",
      "exampleDeadline": "2025/12/15",
      "exampleCount": "3",
      "exampleCompany": "شركة نموذجية محدودة",
      "exampleContact": "أحمد علي",
      "exampleNotes": "يرجى ملاحظة الصور المرفقة."
    }
  },
  "systemSettings": {
    "accessDeniedTitle": "تم رفض الوصول",
    "accessDeniedMessage": "فقط المستخدمون المتميزون (SUPERUSER) (مسؤولو SaaS) يمكنهم الوصول إلى إعدادات النظام.",
    "accessDeniedToast": "فقط المستخدمون المتميزون (SUPERUSER) يمكنهم الوصول إلى إعدادات النظام",
    "loadingSettings": "جاري تحميل الإعدادات...",
    "title": "إعدادات النظام",
    "subtitle": "SUPERUSER - التكوين العام للنظام",
    "tabGemini": "إعدادات الذكاء الاصطناعي",
    "tabDetection": "الكشف",
    "tabTrades": "التخصصات",
    "tabDefects": "العيوب",
    "tabOffline": "غير متصل",
    "tabData": "البيانات",
    "unsavedChanges": "تغييرات غير محفوظة",
    "cancel": "إلغاء",
    "save": "حفظ",
    "saving": "جاري الحفظ...",
    "geminiTitle": "تكوين الذكاء الاصطناعي",
    "geminiDescription": "إعدادات API للكشف عن العيوب المدعوم بالذكاء الاصطناعي",
    "geminiApiKeyLabel": "مفتاح API",
    "geminiApiKeyPlaceholder": "أدخل مفتاح API...",
    "geminiApiKeyHelper": "مفتاح API الذكاء الاصطناعي - يُستخدم لجميع التحليلات",
    "geminiModelLabel": "النموذج",
    "geminiModelPlaceholder": "نموذج الذكاء الاصطناعي",
    "geminiModelHelper": "نموذج الذكاء الاصطناعي المستخدم للتحليلات",
    "analysisLanguageLabel": "لغة تحليل الذكاء الاصطناعي (على مستوى النظام)",
    "analysisLanguageHelper": "تنطبق هذه اللغة على جميع المحتوى المُنشأ بواسطة الذكاء الاصطناعي (التحليلات، وصف العيوب، الحلول). تبقى معرفات أنواع العيوب بالإنجليزية للاتساق.",
    "geminiPromptLabel": "مطالبة النظام",
    "geminiPromptPlaceholder": "حلل صورة البناء هذه بحثًا عن عيوب محتملة...",
    "geminiPromptHelper": "تعليمات للذكاء الاصطناعي - تحدد ما يتم تحليله وكيف يتم تحليله",
    "detectionTitle": "معلمات الكشف",
    "detectionDescription": "الضبط الدقيق لكشف العيوب",
    "detectionConfidenceLabel": "عتبة الثقة",
    "detectionConfidenceHelper": "الحد الأدنى للثقة للعيوب المكتشفة",
    "detectionMaxLabel": "الحد الأقصى للاكتشافات",
    "detectionMaxHelper": "الحد الأقصى لعدد العيوب لكل تحليل",
    "tradesTitle": "إدارة التخصصات",
    "tradesDescription": "التخصصات المتاحة لكشف العيوب",
    "tradesActiveLabel": "التخصصات المفعلة",
    "tradesCustomLabel": "(مخصص)",
    "tradesAddLabel": "إضافة تخصص جديد",
    "tradesAddPlaceholder": "مثال: أعمال الدهان",
    "tradesAddButton": "إضافة",
    "tradesDefaultHeating": "التدفئة",
    "tradesDefaultVentilation": "التهوية",
    "tradesDefaultPlumbing": "السباكة",
    "tradesDefaultDrywall": "الجبس",
    "tradesDefaultElectrical": "الكهرباء",
    "defectsTitle": "إدارة العيوب",
    "defectsDescription": "فئات العيوب المتاحة للكشف",
    "defectsActiveLabel": "العيوب المفعلة",
    "defectsCustomLabel": "(مخصص)",
    "defectsAddLabel": "إضافة فئة عيب جديدة",
    "defectsAddPlaceholder": "مثال: عزل مفقود",
    "defectsAddButton": "إضافة",
    "defectsDefaultMissingInsulation": "عزل مفقود",
    "defectsDefaultMissingLabeling": "ملصقات مفقودة",
    "defectsDefaultMissingGrounding": "تأريض مفقود",
    "defectsDefaultExposedWiring": "أسلاك مكشوفة",
    "defectsDefaultWrongSpacing": "حماية الحواف مفقودة",
    "defectsDefaultContamination": "تلوث/حطام بناء",
    "defectsDefaultImproperInstallation": "تركيب غير لائق",
    "defectsDefaultSafetyHazard": "خطر على السلامة",
    "defectsDefaultMaterialDefect": "عيب مادي",
    "offlineTitle": "الوضع غير متصل",
    "offlineDescription": "إعدادات التشغيل دون اتصال للتطبيق",
    "offlineAutoSyncLabel": "المزامنة التلقائية",
    "offlineAutoSyncHelper": "مزامنة التحليلات دون اتصال تلقائيًا عند الاتصال بالإنترنت",
    "offlineMaxQueueLabel": "الحد الأقصى لحجم قائمة الانتظار",
    "offlineMaxQueueValue": "{count} تحليلات",
    "offlineMaxQueueHelper": "الحد الأقصى لعدد التحليلات المخزنة دون اتصال",
    "offlinePushLabel": "إشعارات الدفع",
    "offlinePushHelper": "إشعارات لحالة المزامنة والأخطاء",
    "dataTitle": "إدارة البيانات",
    "dataDescription": "استيراد وتصدير إعدادات النظام",
    "dataWarning": "تحذير: الاستيراد سيحل محل جميع الإعدادات الحالية!",
    "dataExportLabel": "تصدير الإعدادات",
    "dataExportHelper": "تصدير جميع إعدادات النظام كملف JSON",
    "dataExportButton": "تصدير",
    "dataImportLabel": "استيراد الإعدادات",
    "dataImportHelper": "استيراد إعدادات النظام من ملف JSON",
    "dataExportSuccess": "تم تصدير الإعدادات",
    "dataImportSuccess": "تم استيراد الإعدادات",
    "dataImportError": "خطأ في الاستيراد: ملف JSON غير صالح",
    "tabFeatures": "الميزات",
    "featuresTitle": "إدارة الميزات",
    "featuresDescription": "تفعيل أو تعطيل الميزات. يمكن فقط للمستخدم المتميز تبديل الميزات. الأدوار المسموح بها ترى الميزة عند تفعيلها.",
    "featuresAllowedRoles": "الأدوار المسموح بها",
    "tabApp": "تحديث التطبيق",
    "appTitle": "تحديث إجباري للتطبيق",
    "appDescription": "يحظر التطبيقات الأصلية الأقدم من الحد الأدنى للإصدار حتى يحدّث المستخدمون من المتجر.",
    "appMinVersionLabel": "الحد الأدنى لإصدار التطبيق",
    "appMinVersionPlaceholder": "مثال 1.3.0",
    "appMinVersionHelper": "التطبيقات الأصلية الأقدم من هذا الإصدار تعرض شاشة حظر. اتركه فارغًا للتعطيل.",
    "appMinVersionWarning": "اضبطه فقط على إصدار منشور بالفعل في المتجر، وإلا سيُحظر المستخدمون دون إمكانية التحديث. يسري خلال ~60 ثانية. للتطبيق الأصلي فقط؛ الويب يُحدّث تلقائيًا."
  },
  "login": {
    "title": "تسجيل الدخول",
    "subtitle": "قم بتسجيل الدخول للمتابعة",
    "emailLabel": "البريد الإلكتروني",
    "emailPlaceholder": "your.email@test.com",
    "passwordLabel": "كلمة المرور",
    "passwordPlaceholder": "كلمة المرور الخاصة بك",
    "loginButton": "تسجيل الدخول",
    "loggingIn": "جاري تسجيل الدخول...",
    "loginFailed": "فشل تسجيل الدخول",
    "invalidCredentials": "بيانات اعتماد غير صالحة"
  },
  "setupPassword": {
    "title": "تعيين كلمة المرور",
    "subtitle": "مرحبًا بك في ZeroSnag! قم بتعيين كلمة المرور الخاصة بك للبدء.",
    "newPasswordLabel": "كلمة مرور جديدة *",
    "newPasswordPlaceholder": "8 أحرف على الأقل",
    "confirmPasswordLabel": "تأكيد كلمة المرور *",
    "confirmPasswordPlaceholder": "أعد إدخال كلمة المرور",
    "passwordRequirements": "متطلبات كلمة المرور:",
    "requirementMinLength": "8 أحرف على الأقل",
    "requirementMatch": "كلمتا المرور متطابقتان",
    "setPasswordButton": "تعيين كلمة المرور وتسجيل الدخول",
    "settingPassword": "جاري تعيين كلمة المرور...",
    "roleLabel": "الدور:",
    "roleAdmin": "مسؤول",
    "roleSiteManager": "مدير الموقع",
    "invalidLink": "رابط غير صالح",
    "invalidLinkDescription": "رابط الدعوة هذا غير صالح أو انتهت صلاحيته. يرجى طلب رابط جديد.",
    "goToLoginButton": "الذهاب إلى تسجيل الدخول",
    "alreadySetup": "تم الإعداد بالفعل",
    "alreadySetupDescription": "لقد قمت بتسجيل الدخول بالفعل وقمت بتعيين كلمة المرور الخاصة بك.",
    "goToAppButton": "الذهاب إلى التطبيق",
    "errorProcessingInvite": "خطأ في معالجة رابط الدعوة",
    "inviteLinkUsed": "تم استخدام رابط الدعوة هذا بالفعل",
    "passwordsDontMatch": "كلمتا المرور غير متطابقتين",
    "passwordTooShort": "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
    "errorSettingPassword": "خطأ في تعيين كلمة المرور: {error}",
    "passwordSetSuccess": "تم تعيين كلمة المرور بنجاح! جاري تسجيل دخولك...",
    "unknownError": "خطأ غير معروف"
  },
  "confirmEmail": {
    "title": "تأكيد البريد الإلكتروني",
    "subtitle": "اضغط على الزر لتأكيد عنوان بريدك الإلكتروني.",
    "confirmButton": "تأكيد البريد الإلكتروني",
    "confirming": "جارٍ التأكيد...",
    "doneTitle": "تم تأكيد البريد الإلكتروني",
    "doneDescription": "شكرًا لك! نقوم بمراجعة طلبك وسنقوم بتفعيل حسابك. ستصلك رسالة بريد إلكتروني بمجرد أن تتمكن من البدء.",
    "invalidTitle": "رابط غير صالح",
    "invalidDescription": "رابط التأكيد هذا غير صالح أو تم استخدامه بالفعل. يرجى التسجيل مرة أخرى.",
    "goToLoginButton": "الذهاب إلى تسجيل الدخول"
  },
  "resetPassword": {
    "title": "تعيين كلمة مرور جديدة",
    "subtitle": "اختر كلمة مرور جديدة لحسابك في ZeroSnag.",
    "newPasswordLabel": "كلمة المرور الجديدة",
    "newPasswordPlaceholder": "8 أحرف على الأقل",
    "confirmPasswordLabel": "تأكيد كلمة المرور",
    "confirmPasswordPlaceholder": "أعد إدخال كلمة المرور",
    "requirementMinLength": "8 أحرف على الأقل",
    "requirementMatch": "كلمتا المرور متطابقتان",
    "saveButton": "حفظ كلمة المرور",
    "saving": "جاري الحفظ...",
    "passwordMismatch": "كلمتا المرور غير متطابقتين.",
    "passwordTooShort": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
    "updateFailed": "تعذر تعيين كلمة المرور: {error}",
    "sessionLost": "انتهت الجلسة. يرجى طلب الرابط مرة أخرى.",
    "success": "تم تغيير كلمة المرور — تم تسجيل دخولك الآن.",
    "invalidTitle": "الرابط غير صالح أو منتهي الصلاحية",
    "invalidDescription": "يرجى طلب رابط جديد عبر «هل نسيت كلمة المرور؟» في شاشة تسجيل الدخول.",
    "toLogin": "الذهاب إلى تسجيل الدخول",
    "unknownError": "خطأ غير معروف"
  },
  "completeProfile": {
    "title": "مرحبًا بك في ZeroSnag!",
    "subtitle": "أكمل ملفك الشخصي للبدء",
    "emailLabel": "البريد الإلكتروني",
    "nameLabel": "الاسم",
    "nameOptional": "(اختياري)",
    "namePlaceholder": "مثال: أحمد علي",
    "companyLabel": "الشركة",
    "companyOptional": "(اختياري)",
    "companyPlaceholder": "مثال: شركة إنبيلنيا",
    "saveButton": "إكمال الملف الشخصي",
    "saving": "جاري الحفظ...",
    "footerNote": "بعد الحفظ، يمكنك تسجيل الدخول باستخدام بريدك الإلكتروني وكلمة المرور",
    "acceptInviteFirst": "الرجاء قبول بريد الدعوة أولاً",
    "sessionExpired": "انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.",
    "profileCompletedSuccess": "تم إكمال الملف الشخصي بنجاح!",
    "profileCreateFailed": "فشل إنشاء الملف الشخصي",
    "profileCreatedJoinTeamFailed": "تم إنشاء الملف الشخصي، ولكن حدث خطأ في الانضمام إلى فريق المشروع",
    "unknownError": "تعذر إكمال الملف الشخصي"
  },
  "billing": {
    "title": "الفواتير والاستخدام",
    "subtitle": "إدارة اشتراكك ومراقبة الاستخدام",
    "currentSubscription": "الاشتراك الحالي",
    "subscriptionName": "ZeroSnag Professional",
    "status": {
      "active": "نشط",
      "inactive": "غير نشط",
      "canceled": "ملغى"
    },
    "until": "حتى",
    "price": "السعر:",
    "priceAmount": "49 يورو/شهر",
    "manageSubscription": "إدارة الاشتراك",
    "fairUseLimit": "الاستخدام العادل: 5,000 تحليل شهريًا",
    "subscribeNow": "اشترك الآن",
    "securePayment": "دفع آمن عبر Stripe",
    "loading": "جاري التحميل...",
    "currentUsage": "الاستخدام الحالي - {month}",
    "analysesOf": "من {limit} تحليلات",
    "percentUsed": "{percent}% مستخدم",
    "limitExceeded": "تم تجاوز الحد",
    "limitExceededTitle": "تم تجاوز حد الاستخدام العادل",
    "limitExceededMessage": "لقد تجاوزت الحد الشهري البالغ {limit} تحليلات.",
    "usageHistory": "سجل الاستخدام",
    "totalAnalyses": "الإجمالي: {count} تحليلات",
    "analyses": "تحليلات",
    "featuresTitle": "ZeroSnag Professional - 49 يورو/شهر",
    "featuresDescription": "مع ZeroSnag Professional، يمكنك الوصول إلى ما يصل إلى 5,000 تحليل بالذكاء الاصطناعي شهريًا. هذا يكفي لمعظم مشاريع البناء.",
    "featureUnlimitedProjects": "مشاريع ومقاولون غير محدودين",
    "featureEmailNotifications": "إشعارات البريد الإلكتروني متضمنة",
    "featureAiDetection": "كشف العيوب التلقائي بالذكاء الاصطناعي",
    "featureOfflineMode": "الوضع غير متصل ودعم التطبيق",
    "featureExport": "وظائف التصدير (JSON, PDF)",
    "featureAnalysesPerMonth": "ما يصل إلى 5,000 تحليل/شهر",
    "toastDemoMode": "وضع تجريبي لـ Stripe: {message}",
    "toastCheckoutError": "خطأ في إنشاء جلسة الدفع",
    "toastGeneralError": "خطأ: {message}",
    "toastNoBillingAccount": "لا يوجد اشتراك لهذا الحساب بعد. احصل على ترخيص أولاً.",
    "cancelsAtPeriodEnd": "تم الإلغاء — ينتهي وصولك في {date}."
  },
  "ticketSubmit": {
    "loadingTicket": "جاري تحميل التذكرة...",
    "ticketNotFound": "التذكرة غير موجودة",
    "ticketNotFoundDescription": "تعذر تحميل هذه التذكرة أو أنها غير موجودة.",
    "title": "إصلاح العيب",
    "deadline": "الموعد النهائي:",
    "location": "الموقع:",
    "defectsDetected": "تم اكتشاف {count} عيوب",
    "defectsToFix": "العيوب المراد إصلاحها",
    "uploadPhotosTitle": "رفع صور الإصلاح",
    "uploadPhotosDescription": "انقر لالتقاط الصور",
    "uploadedPhotos": "{count}/5 صور مرفوعة",
    "optionalNote": "💬 ملاحظة اختيارية",
    "notePlaceholder": "أضف ملاحظات حول أعمال الإصلاح هنا...",
    "charactersRemaining": "{count}/500 حرف متبقي",
    "markAsCompleteButton": "وضع علامة كمنجز",
    "confirmationTitle": "تأكيد الإنجاز",
    "confirmationMessage": "هل أنت متأكد من أنه تم إصلاح جميع العيوب وترغب في إرسال هذه التذكرة؟",
    "confirmYes": "نعم، إرسال",
    "confirmSubmitting": "جاري الإرسال...",
    "confirmCancel": "إلغاء",
    "alertMinPhotos": "الرجاء تحميل صورة واحدة على الأقل للعمل المنجز.",
    "alertSuccess": "تم الإرسال بنجاح! تم وضع علامة على التذكرة كمنجزة.",
    "alertError": "خطأ في الإرسال. يرجى المحاولة مرة أخرى.",
    "completedTitle": "تم الإرسال بالفعل",
    "completedDescription": "تم إكمال هذه التذكرة",
    "completedMessage": "شكرًا لك! تم إرسال هذه التذكرة بالفعل ووضع علامة عليها كمنجزة.",
    "project": "المشروع:",
    "inReviewTitle": "قيد المراجعة",
    "inReviewDescription": "مشاركتك قيد المراجعة",
    "inReviewMessage": "شكرًا لك! تم استلام مشاركتك ويتم مراجعتها حاليًا من قبل مدير الموقع.",
    "inReviewNotification": "ستتلقى إشعارًا بمجرد إكمال التذكرة.",
    "invalidTitle": "تذكرة غير صالحة",
    "invalidDescription": "هذه التذكرة لم تعد متاحة",
    "invalidMessage": "تم حذف هذه التذكرة أو أنها لم تعد صالحة.",
    "invalidContact": "الرجاء التواصل مع مدير الموقع.",
    "notFound": {
      "title": "التذكرة غير موجودة",
      "subtitle": "هذه التذكرة لم تعد متاحة",
      "reasonsTitle": "ما الذي كان من الممكن أن يحدث؟",
      "reason1": "تم حذف التذكرة",
      "reason2": "معرّف التذكرة غير صحيح",
      "reason3": "انتهت صلاحية التذكرة",
      "reason4": "رمز الاستجابة السريعة أو الرابط تالف",
      "contactMessage": "الرجاء التواصل مع مدير الموقع للمساعدة أو طلب تذكرة جديدة.",
      "helpTitle": "هل تحتاج إلى مساعدة؟",
      "helpMessage": "تواصل مع مدير الموقع أو منسق المشروع للحصول على المساعدة بخصوص هذه التذكرة.",
      "footerTitle": "نظام ZeroSnag لجودة البناء",
      "footerSubtitle": "ZeroSnag - إدارة جودة البناء"
    },
    "error": {
      "title": "عفوًا! حدث خطأ ما",
      "subtitle": "حدث خطأ أثناء تحميل هذه التذكرة. قد تكون هذه مشكلة مؤقتة.",
      "retryButton": "إعادة المحاولة",
      "supportMessage": "إذا استمرت هذه المشكلة، يرجى التواصل مع الدعم."
    }
  },
  "ticketSubmitCompleted": {
    "successTitle": "نجاح!",
    "successDescription": "تم تقديم عملك بنجاح",
    "nextStepsTitle": "ما هي الخطوات التالية؟",
    "nextStep1": "• سيقوم مدير الموقع بمراجعة صورك",
    "nextStep2": "• سيتم تحديث حالة التذكرة في النظام",
    "nextStep3": "• سيتم الاتصال بك إذا كانت هناك حاجة إلى توضيح",
    "thankYouMessage": "شكرًا لك على التنفيذ الاحترافي لإصلاح العيب.",
    "questionsContact": "أسئلة؟ تواصل مع مدير الموقع",
    "ticketId": "معرّف التذكرة:",
    "footerBrand": "نظام ZeroSnag لجودة البناء"
  },
  "defectSolutions": {
    "button": "الحل",
    "availableSolutions": "الحلول المتاحة",
    "loading": "جاري تحميل اقتراحات الحل...",
    "title": "اقتراح الحل",
    "tabSolutions": "الحلول",
    "solutionNumber": "الحل {number}",
    "noStandards": "لا توجد معايير محددة متاحة",
    "noPrevention": "لا توجد تدابير وقائية متاحة"
  },
  "analysisDetailsModal": {
    "title": "تفاصيل التحليل",
    "edit": "تعديل",
    "promptPlaceholder": "تفاصيل إضافية للذكاء الاصطناعي (اختياري)",
    "examplePlaceholder": "مثال: 'فحص أنابيب المياه في القبو' أو 'فحص التركيبات الكهربائية الطابق الثاني'",
    "shortcuts": "Ctrl+Enter للحفظ · Esc للإغلاق",
    "cancel": "إلغاء",
    "save": "حفظ"
  },
  "locationDetailsModal": {
    "title": "تفاصيل الموقع",
    "edit": "تعديل",
    "placeholder": "مثال: الطابق الثالث، الغرفة 214",
    "cancelWithShortcut": "إلغاء (Esc)",
    "saveWithShortcut": "حفظ (Enter)"
  },
  "analysisModal": {
    "selectProject": "اختر مشروع",
    "noProject": "لا يوجد مشروع",
    "versionsCount": "{count} إصدارات",
    "versions": "{count} إصدارات",
    "noDefects": "لم يتم اكتشاف أي عيوب"
  },
  "projectSelector": {
    "projectName": "اسم المشروع",
    "description": "الوصف",
    "address": "العنوان",
    "namePlaceholder": "مثال: مستشفى جامعة هايدلبرغ",
    "descriptionPlaceholder": "وصف المشروع الاختياري",
    "addressPlaceholder": "عنوان المشروع",
    "selectProject": "اختر مشروع",
    "loading": "جاري تحميل المشاريع...",
    "noProjects": "لم يتم العثور على مشاريع",
    "newProject": "إنشاء مشروع جديد",
    "switch": "تبديل",
    "analysesAndDefects": "التحليلات · العيوب",
    "projectLabel": "المشروع:",
    "createProject": "إنشاء مشروع"
  },
  "aiPricing": {
    "priceUpdated": "تم تحديث السعر",
    "description": "إدارة أسعار API الذكاء الاصطناعي لحساب التكلفة. يتم حفظ الأسعار مع كل تحليل للدقة التاريخية.",
    "noPrices": "لم يتم تكوين الأسعار. سيتم تحميل الأسعار تلقائيًا من قاعدة البيانات.",
    "active": "نشط",
    "inputPrice": "سعر الإدخال",
    "outputPrice": "سعر الإخراج",
    "inputPricePer1M": "سعر الإدخال (لكل مليون رمز)",
    "outputPricePer1M": "سعر الإخراج (لكل مليون رمز)"
  },
  "recentActivity": {
    "noDefects": "لا توجد عيوب",
    "title": "الأنشطة الأخيرة",
    "noActivities": "لا توجد أنشطة بعد",
    "noActivitiesDescription": "ابدأ أول تحليل لرؤية الأنشطة هنا.",
    "showAllActivities": "عرض جميع الأنشطة",
    "pending": "قيد الانتظار"
  },
  "offlineIndicator": {
    "online": "متصل",
    "offline": "غير متصل",
    "pending": "قيد الانتظار:",
    "inProgress": "قيد التنفيذ:",
    "error": "خطأ:",
    "snagsPending": "{count, plural, one {عيب واحد ينتظر} other {# عيوب تنتظر}} الرفع",
    "processingMessage": "سيتم رفع العيوب تلقائياً بمجرد استعادة الاتصال",
    "retryFailed": "إعادة المحاولة للفاشلة",
    "retryPending": "إعادة المحاولة",
    "allDone": "تمت معالجة جميع العيوب",
    "slowConnection": "اتصال بطيء",
    "slowProcessingMessage": "سرعة الرفع منخفضة جداً — سيتم رفع العيوب عندما يصبح الاتصال أسرع"
  },
  "defectSolution": {
    "aiGenerated": "من إنشاء الذكاء الاصطناعي",
    "standards": "المعايير",
    "prevention": "الوقاية",
    "correctMark": "✓ الطريقة الصحيحة",
    "relevantStandards": "المعايير واللوائح ذات الصلة",
    "preventionMeasures": "تدابير الوقاية",
    "position": "الموقع"
  },
  "usageWidget": {
    "monthlyUsage": "الاستخدام الشهري",
    "consumption": "الاستهلاك",
    "forecastWarning": "تحذير التنبؤ",
    "fairUsePolicy": "سياسة الاستخدام العادل"
  },
  "notificationSettings": {
    "pushNotifications": "إشعارات الدفع",
    "notSupported": "غير مدعوم",
    "permissionGranted": "تم منح الإذن"
  },
  "tradeBadges": {
    "detectedTrades": "التخصصات المكتشفة"
  },
  "backgroundSwitcher": {
    "changeBackground": "تغيير الخلفية",
    "backgroundLabel": "الخلفية:"
  },
  "defectResults": {
    "analysisResults": "نتائج التحليل"
  },
  "navbar": {
    "navigation": "التنقل",
    "offlineBanner": "وضع عدم الاتصال — التقاط الصور فقط متاح"
  },
  "feedbackDialog": {
    "menuItem": "الإبلاغ عن خطأ / ملاحظات",
    "title": "الإبلاغ عن خطأ / ملاحظات",
    "description": "صف المشكلة أو اقتراحك — تصل الرسالة مباشرة إلى فريق التطوير.",
    "categoryBug": "خطأ",
    "categoryFeedback": "ملاحظات",
    "messageLabel": "الرسالة",
    "messagePlaceholder": "ماذا حدث؟ وماذا كنت تتوقع؟",
    "imageLabel": "لقطة شاشة/صورة (اختياري)",
    "imageSelect": "اختيار صورة",
    "imageRemove": "إزالة",
    "imageError": "تعذرت معالجة الصورة.",
    "submit": "إرسال",
    "sending": "جارٍ الإرسال…",
    "success": "شكرًا! تم إرسال ملاحظاتك.",
    "error": "فشل الإرسال. يرجى المحاولة مرة أخرى.",
    "offlineHint": "لا يوجد اتصال — يرجى المحاولة لاحقًا."
  },
  "userProvider": {
    "loadingApp": "جاري تحميل ZeroSnag..."
  },
  "performanceMonitor": {
    "navigationLabel": "التنقل:"
  },
  "unifiedImage": {
    "canvasLoading": "جاري تحميل اللوحة...",
    "loadingImage": "جاري تحميل الصورة...",
    "errorLoading": "خطأ في تحميل الصورة",
    "defectsDetected": "تم اكتشاف {count} عيوب",
    "normalView": "عادي",
    "canvasView": "كانفاس",
    "defectsBadge": "{count} عيوب",
    "detectedDefectsLabel": "العيوب المكتشفة:"
  },
  "clipboard": {
    "copied": "تم نسخ الرابط إلى الحافظة",
    "copyError": "خطأ في النسخ"
  },
  "canvas": {
    "clickToSelect": "انقر للاختيار",
    "tapToSelect": "انقر مرة أخرى للاختيار",
    "confidence": "الثقة:",
    "uploadingImage": "جاري رفع الصورة...",
    "startAnalysis": "بدء التحليل",
    "results": "النتائج",
    "orManualCapture": "أو الحفظ بدون تحليل بالذكاء الاصطناعي",
    "addToInspection": "إضافة إلى الجولة",
    "createRequest": "طلب"
  },
  "dataExport": {
    "title": "تصدير البيانات",
    "timeRangeLabel": "الفترة الزمنية (اختياري)",
    "fromLabel": "من",
    "toLabel": "إلى",
    "optionsLabel": "الخيارات",
    "includeImageUrls": "تضمين روابط الصور",
    "selectFormat": "اختر تنسيق التصدير",
    "jsonFormat": "بيانات منظمة",
    "csvFormat": "بيانات جدولية",
    "excelFormat": "مصنف",
    "exporting": "جاري تصدير البيانات...",
    "gdprNotice": "ملاحظة",
    "gdprDescription": "يحتوي التصدير على جميع بيانات التحليل بما في ذلك الصور والمعلومات الشخصية. يرجى مراعاة إرشادات اللائحة العامة لحماية البيانات (GDPR) عند التعامل مع هذه البيانات.",
    "exportFailed": "فشل التصدير",
    "exportFailedRetry": "فشل التصدير. يرجى المحاولة مرة أخرى."
  },
  "liveVideo": {
    "analysisInterval": "فاصل التحليل:",
    "oneSecond": "1 ثانية",
    "twoSeconds": "2 ثانية",
    "fiveSeconds": "5 ثواني",
    "frames": "الإطارات:",
    "analyzing": "جاري التحليل...",
    "ready": "جاهز",
    "defect": "عيب",
    "defects": "عيوب"
  },
  "camera": {
    "permissionDenied": "تعذر فتح الكاميرا. يرجى التحقق من الإذن.",
    "openCamera": "فتح الكاميرا",
    "uploadImage": "رفع صورة",
    "instructions": "التقط صورة أو قم بتحميل صورة للتحليل",
    "capturedImageAlt": "الصورة الملتقطة",
    "promptHeader": "صورة",
    "promptPhoto": "من المعرض",
    "promptPicture": "التقط صورة",
    "promptCancel": "إلغاء"
  },
  "email": {
    "common": {
      "autoGenerated": "تم إنشاء هذا البريد الإلكتروني تلقائيًا."
    },
    "tickets": {
      "subject": "إصلاح العيب مطلوب - {{projektName}}",
      "header": "🔧 إصلاح العيب مطلوب",
      "greeting": "عزيزي/عزيزتي {{ansprechpartner}}،",
      "intro": "كجزء من فحص موقع البناء للمشروع، تم اكتشاف العيوب التالية كجزء من مراقبة الجودة لدينا، والتي نطلب منك معالجتها على الفور:",
      "projectLabel": "المشروع:",
      "locationLabel": "الموقع:",
      "deadlineLabel": "الموعد النهائي للإصلاح:",
      "defectCountLabel": "عدد العيوب:",
      "digitalReporting": "📱 الإبلاغ الرقمي عن العيوب",
      "qrInstructions": "امسح رمز الاستجابة السريعة هذا بهاتفك الذكي لتوثيق الإصلاح مباشرة:",
      "detectedDefects": "العيوب المكتشفة:",
      "notes": "ملاحظات:",
      "reportingInstructions": "كيفية الإبلاغ عن الإصلاح:",
      "reportingStep1": "امسح رمز الاستجابة السريعة أو افتح الرابط أدناه",
      "reportingStep2": "حمّل صور العيوب التي تم إصلاحها",
      "reportingStep3": "أضف ملاحظات اختيارية",
      "reportingStep4": "تأكيد الإنجاز",
      "contactInfo": "للاستفسارات، يرجى التواصل مع مدير الموقع.",
      "signature": "مع أطيب التحيات،<br>فريق ZeroSnag الخاص بك",
      "printTip": "<strong>نصيحة:</strong> اطبع هذا البريد الإلكتروني بحجم A4 وقم بتعليقه في الموقع حتى يتمكن المقاول من رؤية العيوب في الموقع.",
      "severityHigh": "مرتفع",
      "severityMedium": "متوسط",
      "severityLow": "منخفض",
      "ticketLink": "رابط التذكرة:",
      "viewTicket": "عرض التذكرة",
      "infoBox": {
        "project": "المشروع",
        "location": "الموقع",
        "deadline": "الموعد النهائي",
        "defectCount": "عدد العيوب"
      }
    },
    "fallback": {
      "warning": "⚠️ تعذر إرسال البريد الإلكتروني إلى المقاول",
      "reason": "السبب:",
      "contractor": "المقاول:",
      "action": "الإجراء:"
    },
    "defectNotification": {
      "subject": "🚨 ZeroSnag: عيب جديد في {projectName}",
      "header": "🚨 ZeroSnag كشف العيوب",
      "subheader": "تم اكتشاف وتأكيد عيب جديد",
      "projectLabel": "المشروع:",
      "reporterLabel": "تم الإبلاغ بواسطة:",
      "timestampLabel": "الطابع الزمني:",
      "defectSectionTitle": "🔍 العيب المكتشف",
      "descriptionLabel": "الوصف:",
      "recommendationLabel": "التوصية:",
      "imageSectionTitle": "📸 صورة",
      "imageButtonText": "عرض الصورة",
      "actionsSectionTitle": "📋 الخطوات التالية",
      "action1": "التحقق من العيب في الموقع",
      "action2": "تعيين العيب إلى التخصص المسؤول",
      "action3": "التخطيط للإصلاح",
      "action4": "توثيق الإصلاح في ZeroSnag",
      "footerAutoGenerated": "تم إنشاء هذا البريد الإلكتروني تلقائيًا بواسطة ZeroSnag.",
      "footerCopyright": "© 2025 ZeroSnag - فحص موقع البناء المدعوم بالذكاء الاصطناعي"
    },
    "test": {
      "subject": "ZeroSnag - بريد إلكتروني اختباري",
      "heading": "بريد إلكتروني اختباري",
      "body": "هذا بريد إلكتروني اختباري من ZeroSnag.",
      "timestamp": "الطابع الزمني:"
    }
  },
  "components": {
    "defectResults": {
      "defectsCount": "{count} عيوب",
      "okCount": "{count} موافق",
      "uncertainCount": "{count} غير واضح",
      "defectDetected": "تم اكتشاف عيب",
      "noDefectsFound": "لم يتم العثور على عيوب. جميع الكائنات {okCount} التي تم فحصها على ما يرام.",
      "uncertainObjects": "تعذر تصنيف {count} كائن{plural} بشكل واضح."
    },
    "analysisModal": {
      "confidencePercent": "{percent}% ثقة",
      "recommendation": "التوصية:",
      "reScan": "إعادة المسح"
    },
    "projectSelector": {
      "createFirstProject": "إنشاء أول مشروع",
      "projectName": "اسم المشروع *",
      "description": "الوصف",
      "address": "العنوان",
      "createProject": "إنشاء مشروع",
      "namePlaceholderExample": "مثال: مستشفى جامعة هايدلبرغ",
      "descriptionPlaceholder": "وصف المشروع الاختياري",
      "addressPlaceholder": "عنوان المشروع",
      "newProject": "إنشاء مشروع جديد"
    },
    "usageWidget": {
      "of": "من {limit}",
      "projectionWarning": "بالاستخدام الحالي: <strong>{projectedUsage}</strong> تحليلات حتى نهاية الشهر. هذا <strong>{over}</strong> فوق الحد!",
      "fairUseWarning": "أنت تقترب من الحد الشهري. قد يتم تطبيق رسوم إضافية في حالة التجاوز.",
      "optimalUsage": "✨ استخدام مثالي! أنت ضمن الميزانية لهذا الشهر."
    },
    "recentActivity": {
      "analysisIn": "تحليل في {project}"
    },
    "backgroundSwitcher": {
      "paperOnly": "📄 ورق فقط",
      "gradientOnly": "🌈 تدرج فقط",
      "bothCombined": "✨ كلاهما مجتمع",
      "noneClean": "⚪ لا شيء (نظيف)"
    },
    "loginForm": {
      "loginFailed": "فشل تسجيل الدخول",
      "subtitle": "قم بتسجيل الدخول للمتابعة",
      "email": "البريد الإلكتروني",
      "emailPlaceholder": "your.email@test.com",
      "password": "كلمة المرور",
      "passwordPlaceholder": "كلمة المرور الخاصة بك",
      "signingIn": "جاري تسجيل الدخول...",
      "signIn": "تسجيل الدخول",
      "forgotLink": "هل نسيت كلمة المرور؟",
      "forgotTitle": "إعادة تعيين كلمة المرور",
      "forgotIntro": "أدخل بريدك الإلكتروني — سنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
      "forgotSubmit": "إرسال رابط إعادة التعيين",
      "forgotSending": "جاري الإرسال...",
      "forgotSent": "إذا كان هناك حساب بهذا البريد الإلكتروني، فقد أرسلنا إليك رسالة تحتوي على رابط لإعادة تعيين كلمة المرور. يرجى التحقق من مجلد الرسائل غير المرغوب فيها أيضًا.",
      "forgotFailed": "فشل الطلب. يرجى المحاولة مرة أخرى لاحقًا.",
      "forgotNetworkError": "خطأ في الشبكة. يرجى المحاولة مرة أخرى لاحقًا.",
      "backToLogin": "العودة إلى تسجيل الدخول",
      "noAccount": "ليس لديك حساب بعد؟",
      "registerLink": "جرّبه مجاناً",
      "registerLinkNeutral": "إنشاء حساب"
    },
    "errorBoundary": {
      "title": "حدث خطأ ما",
      "description": "حدث خطأ غير متوقع",
      "devModeDetails": "وضع المطور: عرض تفاصيل الخطأ",
      "retry": "إعادة المحاولة"
    },
    "appBanner": {
      "message": "ZeroSnag كتطبيق – يعمل أيضًا دون اتصال في موقع البناء.",
      "cta": "تحميل التطبيق",
      "dismiss": "إغلاق"
    },
    "mobileTabBar": {
      "dashboard": "الإحصائيات",
      "detect": "تحليل ذكي",
      "history": "السجل",
      "projects": "المشاريع",
      "tickets": "التذاكر"
    },
    "breadcrumbs": {
      "home": "الرئيسية"
    },
    "imageCapture": {
      "openCamera": "فتح الكاميرا",
      "uploadImage": "رفع صورة",
      "instructions": "التقط صورة أو قم بتحميل صورة للتحليل",
      "capturedImageAlt": "الصورة الملتقطة"
    },
    "tradeBadges": {
      "heating": "التدفئة",
      "ventilation": "التهوية",
      "plumbing": "السباكة",
      "drywall": "الجبس",
      "electrical": "الكهرباء"
    },
    "qrCode": {
      "copied": "تم النسخ!",
      "copyLink": "نسخ الرابط"
    }
  },
  "pages": {
    "completeProfile": {
      "acceptInviteFirst": "الرجاء قبول بريد الدعوة أولاً",
      "updateError": "فشل تحديث الملف الشخصي",
      "joinProjectError": "تم إنشاء الملف الشخصي، ولكن حدث خطأ في الانضمام إلى فريق المشروع",
      "success": "تم إكمال الملف الشخصي بنجاح!",
      "generalError": "تعذر إكمال الملف الشخصي",
      "loginHelper": "بعد الحفظ، يمكنك تسجيل الدخول باستخدام بريدك الإلكتروني وكلمة المرور"
    },
    "setupPassword": {
      "inviteLinkError": "خطأ في معالجة رابط الدعوة",
      "linkAlreadyUsed": "تم استخدام رابط الدعوة هذا بالفعل",
      "passwordMismatch": "كلمتا المرور غير متطابقتين",
      "passwordTooShort": "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
      "setPasswordError": "خطأ في تعيين كلمة المرور: {error}",
      "success": "تم تعيين كلمة المرور بنجاح! جاري تسجيل دخولك...",
      "invalidLinkTitle": "رابط غير صالح",
      "invalidLinkMessage": "رابط الدعوة هذا غير صالح أو انتهت صلاحيته. يرجى طلب رابط جديد.",
      "toLogin": "الذهاب إلى تسجيل الدخول",
      "alreadySetupTitle": "تم الإعداد بالفعل",
      "alreadySetupMessage": "لقد قمت بتسجيل الدخول بالفعل وقمت بتعيين كلمة المرور الخاصة بك.",
      "toApp": "الذهاب إلى التطبيق",
      "welcomeMessage": "مرحبًا بك في ZeroSnag! قم بتعيين كلمة المرور الخاصة بك للبدء.",
      "roleLabel": "الدور:",
      "newPasswordLabel": "كلمة مرور جديدة *",
      "passwordPlaceholder": "8 أحرف على الأقل",
      "confirmPasswordLabel": "تأكيد كلمة المرور *",
      "confirmPasswordPlaceholder": "أعد إدخال كلمة المرور",
      "requirementsTitle": "متطلبات كلمة المرور:",
      "requirement8Chars": "8 أحرف على الأقل",
      "requirementMatch": "كلمتا المرور متطابقتان",
      "settingPassword": "جاري تعيين كلمة المرور...",
      "submitButton": "تعيين كلمة المرور وتسجيل الدخول"
    }
  },
  "time": {
    "seconds": "{seconds} ثواني",
    "minutes": "{minutes}:{seconds} دقيقة"
  },
  "analysisProgress": {
    "starting": "بدء التحليل...",
    "step1": "تهيئة الشبكات العصبونية...",
    "step2": "تحميل نموذج محول الرؤية...",
    "step3": "معايرة مصفوفة التعرف على الصور...",
    "step4": "استخراج خرائط الميزات متعددة المقاييس...",
    "step5": "تنفيذ تحليل الطبقة الالتفافية...",
    "step6": "حساب أوزان آلية الانتباه...",
    "step7": "تحليل تجزئة الصورة الدلالية...",
    "step8": "معالجة استدلال التعلم العميق...",
    "step9": "تقييم خرائط حرارة اكتشاف الكائنات...",
    "step10": "تحسين انحدارات مربع الإحاطة...",
    "step11": "ربط التضمينات متعددة الوسائط...",
    "step12": "الانتهاء من تصنيف العيوب المدعوم بالذكاء الاصطناعي...",
    "step13": "التحقق من درجات الثقة...",
    "almostDone": "كاد أن ينتهي...",
    "processing": "جاري معالجة الصورة...",
    "uploadingImage": "جاري تحميل الصورة...",
    "gemini": "جاري التحليل بالذكاء الاصطناعي...",
    "defectsFound": "تم العثور على {count} عيوب",
    "complete": "اكتمل التحليل!"
  },
  "app": {
    "tagline": "ZeroSnag - فحص موقع البناء المدعوم بالذكاء الاصطناعي",
    "metadata": {
      "title": "ZeroSnag - كشف العيوب المدعوم بالذكاء الاصطناعي",
      "description": "أداة مدعومة بالذكاء الاصطناعي لمديري المواقع للوقاية الاستباقية من عيوب البناء"
    }
  },
  "roles": {
    "admin": "مسؤول",
    "siteManager": "مدير الموقع"
  },
  "lib": {
    "notifications": {
      "defectQueued": "تمت إضافة اكتشاف العيب الخاص بك للمعالجة",
      "defectsFound": "تم اكتشاف عيوب",
      "noDefectsFound": "لم يتم العثور على عيوب - كل شيء على ما يرام!",
      "processingComplete": "تمت معالجة التحليلات بنجاح",
      "processingSuccess": "ناجح",
      "processingFailed": "فاشل",
      "queuedTitle": "ZeroSnag - التحليل في قائمة الانتظار",
      "processedTitle": "ZeroSnag - اكتمل التحليل",
      "offlineQueueTitle": "ZeroSnag - تمت معالجة قائمة انتظار عدم الاتصال"
    },
    "timing": {
      "seconds": "{seconds} ثواني",
      "minutes": "{minutes}:{seconds} دقيقة"
    },
    "defects": {
      "otherDefect": "عيب آخر",
      "other": "أخرى",
      "unknown": "غير معروف",
      "unknownSeverity": "غير معروف"
    },
    "trades": {
      "heating": "التدفئة",
      "ventilation": "التهوية",
      "plumbing": "السباكة",
      "drywall": "الجبس",
      "electrical": "الكهرباء"
    },
    "objectLabels": {
      "pipe": "أنبوب",
      "pipes": "أنابيب",
      "metalPipe": "أنبوب معدني",
      "copperPipe": "أنبوب نحاسي",
      "plasticPipe": "أنبوب بلاستيكي",
      "heatingPipe": "أنبوب تدفئة",
      "valve": "صمام",
      "ballValve": "صمام كروي",
      "fitting": "وصلة",
      "cable": "كابل",
      "cables": "كابلات",
      "electricalWire": "سلك كهربائي",
      "electricCable": "كابل كهربائي",
      "wire": "سلك",
      "wires": "أسلاك",
      "exposedWire": "سلك مكشوف",
      "duct": "قناة",
      "ventilationDuct": "قناة تهوية",
      "electricalBox": "صندوق كهربائي",
      "junctionBox": "صندوق وصل",
      "pipeInsulation": "عزل الأنابيب",
      "insulationMaterial": "مادة عازلة",
      "constructionDebris": "حطام البناء",
      "rubble": "ركام",
      "dirt": "أوساخ",
      "dust": "غبار",
      "metalSurface": "سطح معدني",
      "wall": "جدار",
      "floor": "أرضية",
      "ceiling": "سقف",
      "concrete": "خرسانة",
      "brick": "طوب",
      "drywall": "جبس",
      "foamInsulation": "عزل رغوي",
      "mineralWool": "صوف معدني",
      "tool": "أداة",
      "ladder": "سلم",
      "scaffolding": "سقالة",
      "bucket": "دلو",
      "box": "صندوق",
      "material": "مادة",
      "constructionMaterial": "مواد بناء",
      "damage": "ضرر",
      "crack": "شق",
      "hole": "ثقب",
      "gap": "فجوة",
      "wallOpening": "فتحة جدار",
      "floorOpening": "فتحة أرضية",
      "leak": "تسرب",
      "waterDamage": "ضرر المياه",
      "hazard": "خطر",
      "danger": "خطر",
      "obstacle": "عائق",
      "unsafeCondition": "حالة غير آمنة"
    }
  },
  "slides": {
    "title": "الحل",
    "solution": "كشف العيوب المدعوم بالذكاء الاصطناعي",
    "detectedDefects": "العيوب المكتشفة"
  },
  "gewerkePopup": {
    "title": "تم اكتشاف حرف كثيرة جداً",
    "description": "تم اكتشاف عيوب من حرف مختلفة كثيرة. يمكنك تضييق التحليل على حرف محددة للحصول على نتائج أدق.",
    "skip": "تخطي",
    "reanalyze": "إعادة التحليل ({count})",
    "analyzing": "جاري التحليل...",
    "defect": "عيب",
    "defects": "عيوب"
  },
  "telegram": {
    "title": "تقرير يومي",
    "subtitle": "بوت تيليجرام والتقارير اليومية",
    "tabOverview": "نظرة عامة",
    "tabUsers": "المستخدمون",
    "tabMessages": "الرسائل",
    "tabReports": "التقارير",
    "botStatus": "حالة البوت",
    "botConfigured": "البوت مُعد",
    "botNotConfigured": "البوت غير مُعد",
    "totalUsers": "مستخدمو تيليجرام",
    "linkedUsers": "مستخدمون مرتبطون",
    "messagesToday": "رسائل اليوم",
    "messagesWeek": "رسائل هذا الأسبوع",
    "reportsWeek": "تقارير هذا الأسبوع",
    "finalizedWeek": "تم الانتهاء هذا الأسبوع",
    "telegramId": "معرف تيليجرام",
    "telegramUser": "مستخدم تيليجرام",
    "linkedTo": "مرتبط بـ",
    "notLinked": "غير مرتبط",
    "activeProject": "المشروع النشط",
    "linkUser": "ربط المستخدم",
    "unlinkUser": "إلغاء الربط",
    "selectUser": "اختر مستخدم ZeroSnag",
    "noMessages": "لم يتم العثور على رسائل",
    "filterByProject": "تصفية حسب المشروع",
    "filterByDate": "تصفية حسب التاريخ",
    "allProjects": "جميع المشاريع",
    "text": "نص",
    "photo": "صورة",
    "voice": "رسالة صوتية",
    "location": "موقع",
    "command": "أمر",
    "transcript": "نسخة",
    "noReports": "لم يتم العثور على تقارير",
    "reportDate": "التاريخ",
    "reportStatus": "الحالة",
    "reportProject": "المشروع",
    "generateReport": "إنشاء تقرير",
    "editReport": "تعديل التقرير",
    "finalizeReport": "إنهاء وإنشاء PDF",
    "downloadPdf": "تحميل PDF",
    "deleteReport": "حذف التقرير",
    "statusDraft": "مسودة",
    "statusGenerating": "جاري الإنشاء",
    "statusGenerated": "تم الإنشاء",
    "statusEdited": "تم التعديل",
    "statusFinalized": "تم الإنهاء",
    "summary": "ملخص",
    "sections": "الأقسام",
    "weather": "الطقس",
    "entries": "المدخلات",
    "projectLocation": "موقع المشروع",
    "setLocation": "تعيين الموقع",
    "searchAddress": "البحث عن عنوان...",
    "confirmDelete": "هل تريد حقاً حذف هذا التقرير؟",
    "reportGenerated": "تم إنشاء التقرير",
    "reportFinalized": "تم إنهاء التقرير",
    "reportDeleted": "تم حذف التقرير",
    "noProject": "لا يوجد مشروع",
    "quickAction": "التقارير اليومية"
  },
  "inspections": {
    "title": "الجولات التفقدية",
    "newInspection": "جولة جديدة",
    "inspectionDate": "تاريخ الجولة",
    "inspectionTitle": "العنوان",
    "participants": "المشاركون",
    "participantName": "الاسم",
    "participantRole": "الدور",
    "addParticipant": "إضافة مشارك",
    "notes": "ملاحظات",
    "locationFilter": "فلتر الموقع",
    "statusFilter": "فلتر الحالة",
    "allStatuses": "جميع الحالات",
    "statusDraft": "مسودة",
    "statusFinalized": "مكتمل",
    "statusArchived": "مؤرشف",
    "addDefects": "إضافة عيوب",
    "photoOnly": "صورة (لم يتم تسجيل عيوب)",
    "removeDefect": "إزالة",
    "generatePdf": "إنشاء PDF",
    "downloadPdf": "تحميل PDF",
    "finalize": "إنهاء الجولة وإرسالها",
    "defectCount": "{count} عيوب",
    "noDefects": "لم يتم تعيين عيوب بعد",
    "noInspections": "لا توجد جولات",
    "noInspectionsDescription": "أنشئ جولة جديدة لتوثيق العيوب.",
    "confirmFinalize": "إنهاء الجولة؟ لا يمكن التراجع.",
    "confirmDelete": "هل تريد حقاً حذف هذه الجولة؟",
    "pdfGenerating": "جارٍ إنشاء PDF...",
    "pdfReady": "تم إنشاء PDF",
    "created": "تم الإنشاء",
    "createdBy": "أنشأه",
    "errorLoading": "خطأ في تحميل الجولات",
    "errorLoadingTitle": "خطأ في التحميل",
    "retryButton": "إعادة المحاولة",
    "showingRange": "عرض {from} إلى {to} من {total}",
    "previous": "السابق",
    "next": "التالي",
    "pagination": "صفحة {page} من {pages}",
    "createSuccess": "تم إنشاء الجولة",
    "updateSuccess": "تم تحديث الجولة",
    "deleteSuccess": "تم حذف الجولة",
    "finalizeSuccess": "تم إنهاء الجولة",
    "defectsAdded": "تمت إضافة العيوب",
    "defectsRemoved": "تمت إزالة العيوب",
    "selectTickets": "اختر التذاكر",
    "noAvailableTickets": "لا توجد تذاكر متاحة",
    "addSelected": "إضافة المحدد",
    "contractor": "المقاول",
    "deadline": "الموعد النهائي",
    "severity": "الخطورة",
    "description": "الوصف",
    "location": "الموقع",
    "back": "العودة للمشروع",
    "new": "جديد",
    "delete": "حذف",
    "cancel": "إلغاء",
    "dateFrom": "من (التاريخ)",
    "dateTo": "إلى (اختياري)",
    "dateToHint": "فارغ = يوم واحد فقط",
    "sameDayPlaceholder": "نفس اليوم",
    "titlePlaceholder": "مثال: فحص الحالة الفنية",
    "locationPlaceholder": "مثال: المبنى أ، الطابق 3",
    "notesPlaceholder": "ملاحظات عامة حول الجولة...",
    "statusFilterPlaceholder": "جميع الحالات (بدون فلتر)",
    "statusFilterHint": "تضمين التذاكر بهذه الحالة فقط",
    "statusOpen": "مفتوح",
    "statusInReview": "قيد المراجعة",
    "statusCompleted": "مكتمل",
    "autoCollectTitle": "جمع العيوب التلقائي",
    "autoCollectDescription": "سيتم إضافة جميع تذاكر العيوب والتقارير من الفترة المحددة تلقائياً. يمكنك إزالة الإدخالات الفردية لاحقاً.",
    "submitting": "جارٍ جمع العيوب...",
    "createButton": "إنشاء جولة",
    "validationRequired": "العنوان والتاريخ مطلوبان",
    "errorCreating": "خطأ في إنشاء الجولة",
    "errorAdding": "خطأ في إضافة العيوب",
    "errorRemoving": "خطأ في إزالة العيوب",
    "errorPdf": "خطأ في إنشاء PDF",
    "errorNoPdf": "لا يوجد PDF",
    "errorFinalizing": "خطأ في الإنهاء",
    "errorDeleting": "خطأ في الحذف",
    "noInspectionsYet": "لا توجد جولات بعد",
    "defaultTrade": "حرفة",
    "defaultClassification": "عيب",
    "image": "صورة",
    "descriptionLabel": "الوصف",
    "locationLabel": "الموقع",
    "contractorLabel": "المقاول",
    "deadlineLabel": "الموعد النهائي",
    "statusLabel": "الحالة",
    "tradeLabel": "الحرفة",
    "sectionTag": "القسم / العلامة",
    "sectionTagPlaceholder": "مثال: \"الطابق الأرضي\"",
    "addDialogTitle": "إضافة صور / عيوب",
    "addToInspection": "إضافة ({count})",
    "noAvailableAnalyses": "لا توجد تحليلات متاحة",
    "noLocation": "بدون موقع",
    "unsorted": "غير مصنف",
    "sendToContractors": "إرسال إلى المقاولين",
    "confirmSendReports": "إرسال تقارير العيوب إلى جميع المقاولين المعينين؟",
    "defectsLabel": "عيوب",
    "dispatchPending": "الإرسال معلق",
    "photoBadge": "صورة",
    "tradeWizard": {
      "title": "تعيين الحرفة",
      "description": "عيب {progress}. يجب تعيين حرفة لكل عيب قبل الإنهاء.",
      "noDescription": "لا يوجد وصف",
      "section": "القسم: {tag}",
      "tradeLabel": "حرفة",
      "acceptAllDefault": "تعيين الباقي كعام",
      "back": "رجوع",
      "skip": "تخطي",
      "next": "التالي",
      "apply": "تطبيق",
      "done": "تم"
    },
    "dispatch": {
      "title": "تأكيد الإرسال",
      "loading": "جارٍ تحميل الحرف والمقاولين…",
      "empty": "لا توجد عيوب في هذه المعاينة.",
      "defectCount": "{count} عيوب",
      "pickContractor": "اختر المقاول",
      "noEmailSuffix": " — بدون بريد",
      "missingEmail": "المقاول بدون بريد إلكتروني — لن يتم الإرسال.",
      "noContractor": "لا يوجد مقاول معيّن لهذه الحرفة في هذا المشروع — لن يتم الإرسال.",
      "manageContractors": "إدارة المقاولين لهذا المشروع",
      "deadlineLabel": "الموعد النهائي لإصلاح العيوب",
      "deadlineHint": "ينطبق على جميع التذاكر التي يتم إنشاؤها الآن.",
      "alreadyTicketedHint": "يتم تخطي العيوب التي لها تذاكر بالفعل.",
      "ticketsCreated": "{count, plural, =1 {تم إنشاء تذكرة واحدة} other {تم إنشاء # تذاكر}}",
      "ticketsSkipped": "{count, plural, =0 {} =1 {تم تخطي عيب واحد (تم الإرسال مسبقًا أو بدون مقاول)} other {تم تخطي # عيوب (تم الإرسال مسبقًا أو بدون مقاول)}}",
      "cancel": "إلغاء",
      "confirm": "إنهاء وإرسال",
      "blockedNoContractor": "لم يتم اختيار أي شركة — سيتم إنهاء الجولة دون إرسال أي إشعار عيوب. اختر شركة واحدة على الأقل أو أضف الشركات إلى المشروع أولاً.",
      "partialContractors": "{count, plural, =1 {لم يتم اختيار شركة لحرفة واحدة — لن يتم إرسال هذه العيوب.} other {لم يتم اختيار شركة لـ # حرف — لن يتم إرسال هذه العيوب.}}",
      "alreadySent": "{count, plural, =1 {تم إرسال عيب واحد مسبقًا ولن يُرسل مرة أخرى.} other {تم إرسال # عيوب مسبقًا ولن تُرسل مرة أخرى.}}"
    },
    "renameTitle": "تعديل الاسم",
    "bulk": {
      "selected": "{count, plural, =1 {تم تحديد عيب واحد} other {تم تحديد # عيوب}}",
      "selectAll": "{count, plural, =1 {تحديد عيب واحد} other {تحديد الكل (#)}}",
      "selectDefect": "تحديد العيب N{number}",
      "clearSelection": "إلغاء التحديد",
      "sendAction": "إرسال إلى المقاول",
      "sendTitle": "{count, plural, =1 {إرسال عيب واحد} other {إرسال # عيوب}}",
      "sendConfirm": "إرسال",
      "sendSuccess": "{count, plural, =1 {تم إرسال عيب واحد} other {تم إرسال # عيوب}}",
      "sendError": "فشل الإرسال.",
      "nothingToSend": "لا يوجد ما يُرسل — كل العيوب المحددة مرتبطة بتذكرة بالفعل.",
      "fixedAction": "وضع علامة تم",
      "reopenAction": "إعادة فتح",
      "fixedSuccess": "{count, plural, =1 {تم إنجاز عيب واحد} other {تم إنجاز # عيوب}}",
      "reopenSuccess": "{count, plural, =1 {تمت إعادة فتح عيب واحد} other {تمت إعادة فتح # عيوب}}",
      "fixedError": "تعذّر الحفظ.",
      "nothingToTick": "صور فقط — لا يوجد ما يمكن وضع علامة عليه.",
      "done": "تم",
      "floor": "الطابق",
      "unit": "الشقة",
      "room": "الغرفة",
      "allFloors": "كل الطوابق",
      "allUnits": "كل الشقق",
      "allRooms": "كل الغرف",
      "clearFilter": "إعادة ضبط عوامل التصفية",
      "shown": "{shown} من {total}",
      "doneByContractor": "تمت الموافقة",
      "tickOffNotAllowed": "داخلي فقط — مدير الموقع أو المسؤول.",
      "ticketsClosed": "{count, plural, =1 {تم إغلاق تذكرة واحدة — لا مزيد من التذكيرات للشركة.} other {تم إغلاق # تذاكر — لا مزيد من التذكيرات للشركات.}}",
      "ticketsReopened": "{count, plural, =1 {تمت إعادة فتح تذكرة واحدة.} other {تمت إعادة فتح # تذاكر.}}"
    }
  },
  "sync": {
    "connecting": "جارٍ الاتصال…",
    "downloading": "جارٍ المزامنة…",
    "uploading": "جارٍ رفع التغييرات…",
    "offline": "غير متصل — يتم حفظ التغييرات محلياً",
    "queuedImages": "{count, plural, =1 {صورة واحدة في قائمة الانتظار} other {# صور في قائمة الانتظار}}",
    "uploadingImages": "{count, plural, =1 {جارٍ رفع صورة واحدة…} other {جارٍ رفع # صور…}}",
    "queuedEmails": "{count, plural, =1 {يتم إرسال رسالة واحدة} other {يتم إرسال # رسائل}}",
    "queuedPdfs": "{count, plural, =1 {يتم إنشاء ملف PDF واحد} other {يتم إنشاء # ملفات PDF}}",
    "reauthRequired": "يرجى تسجيل الدخول مرة أخرى لاستئناف المزامنة.",
    "preparingOffline": "جارٍ تحضير وضع عدم الاتصال…",
    "inSync": "متزامن",
    "stalled": "{count, plural, =1 {تعذرت مزامنة تغيير واحد} other {تعذرت مزامنة # تغييرات}}"
  },
  "pwa": {
    "installTitle": "إضافة إلى الشاشة الرئيسية",
    "installBodyIos": "اضغط على مشاركة ثم „إضافة إلى الشاشة الرئيسية“ — وإلا سيحذف iOS بياناتك المحلية بعد 7 أيام.",
    "dismiss": "حسناً"
  },
  "appUpdate": {
    "updateRequiredTitle": "التحديث مطلوب",
    "updateRequiredBody": "يتوفر إصدار جديد من ZeroSnag. يرجى تحديث التطبيق للمتابعة.",
    "updateButton": "حدّث الآن",
    "newVersionTitle": "يتوفر إصدار جديد",
    "reloadingIn": "سيتم تحديث التطبيق خلال {secs} ثانية…"
  },
  "demoBanner": {
    "title": "وصول تجريبي.",
    "analysesLeft": "بقي {remaining} من {limit} تحليلاً",
    "daysLeft": "{days, plural, one {بقي يوم واحد} other {بقي # أيام}}",
    "nudgeWeb": "احصل على ترخيصك الآن.",
    "nudgeNative": "سنرسل لك الخطوات التالية عبر البريد الإلكتروني.",
    "blockedTitle": "انتهت النسخة التجريبية.",
    "reasonAnalyses": "لقد استنفدت رصيد التحليلات.",
    "reasonExpired": "انتهت فترتك التجريبية.",
    "reasonSubscription": "انتهت صلاحية ترخيصك.",
    "blockedWeb": "احصل على ترخيص لمواصلة استخدام ZeroSnag — تبقى تحليلاتك السابقة متاحة.",
    "blockedNative": "أرسلنا إليك الخطوات التالية عبر البريد الإلكتروني. تبقى تحليلاتك السابقة متاحة.",
    "cta": "احصل على ترخيص",
    "lapsedTitle": "تم إيقاف الوصول مؤقتاً.",
    "lapsedWeb": "أعد تفعيل ترخيصك للمتابعة — تبقى جميع بياناتك كما هي.",
    "lapsedNative": "أرسلنا إليك الخطوات التالية عبر البريد الإلكتروني. تبقى جميع بياناتك كما هي.",
    "ctaRenew": "تجديد الترخيص"
  },
  "demoIntro": {
    "title": "مرحباً بك في ZeroSnag",
    "subtitle": "تم تفعيل وصولك التجريبي. إليك ما يمكن توقعه:",
    "includedAnalyses": "{limit, plural, one {تحليل واحد بالذكاء الاصطناعي مشمول} other {# تحليلاً بالذكاء الاصطناعي مشمولة}} — كل صورة يتم تحليلها تُحتسب مرة واحدة.",
    "includedDays": "{days, plural, one {بقي يوم واحد من الفترة التجريبية} other {بقي # أيام من الفترة التجريبية}} — ينتهي الاشتراك بأيهما ينفد أولاً.",
    "howToStart": "التقط صورة أو ارفعها — يكتشف الذكاء الاصطناعي العيوب تلقائياً ويحددها في الصورة.",
    "whatCounts": "المشاريع وتذاكر العيوب والتقارير غير محدودة وقابلة للتصدير.",
    "afterWeb": "بعد ذلك يبقى كل ما سجّلته متاحاً. للمتابعة، احصل على ترخيص — شهري أو سنوي بخصم.",
    "afterNative": "بعد ذلك يبقى كل ما سجّلته متاحاً. سنراسلك عبر البريد الإلكتروني في الوقت المناسب بالخطوات التالية.",
    "cta": "لنبدأ"
  },
  "board": {
    "title": "المهام",
    "backToProject": "العودة إلى المشروع",
    "viewBoard": "لوحة",
    "viewList": "قائمة",
    "addList": "إضافة قائمة",
    "newListPlaceholder": "مثال: المبنى أ",
    "renameList": "إعادة تسمية",
    "archiveList": "أرشفة القائمة",
    "listActions": "إجراءات القائمة",
    "addCard": "إضافة بطاقة",
    "newCardPlaceholder": "ما المطلوب عمله؟",
    "emptyColumn": "لا توجد بطاقات بعد",
    "emptyTitle": "لا توجد لوحة بعد",
    "emptyHint": "يمكن تسمية القوائم بحرية — غالبًا المباني أو الأقسام أو الحالة.",
    "createFirstList": "إنشاء أول قائمة",
    "defaultListName": "مفتوح",
    "loadingBoard": "جارٍ تحميل اللوحة …",
    "cardCount": "{count, plural, zero {لا توجد بطاقات} one {بطاقة واحدة} two {بطاقتان} few {# بطاقات} many {# بطاقة} other {# بطاقة}} إجمالاً",
    "cardDetails": "بطاقة",
    "titleLabel": "العنوان",
    "descriptionLabel": "الوصف",
    "descriptionPlaceholder": "تفاصيل، الموقع، ما يجب عمله …",
    "dueLabel": "الموعد النهائي",
    "assigneeLabel": "المسؤول",
    "assigneeNone": "لا أحد",
    "groupTeam": "الفريق",
    "groupContractors": "المقاولون",
    "markDone": "وضع علامة تم",
    "reopen": "إعادة فتح",
    "done": "تم",
    "save": "حفظ",
    "cancel": "إلغاء",
    "close": "إغلاق",
    "delete": "حذف",
    "deleteConfirm": "هل تريد الحذف فعلاً؟",
    "dragHandle": "نقل البطاقة «{title}»",
    "toggleDone": "وضع علامة على البطاقة «{title}»",
    "allLists": "كل القوائم",
    "allAssignees": "الجميع",
    "openOnly": "المفتوحة فقط",
    "clearFilter": "إعادة ضبط عوامل التصفية",
    "shown": "{shown} من {total}",
    "noneMatchFilter": "لا توجد بطاقة تطابق عامل التصفية.",
    "overdue": "متأخرة",
    "contractorAccess": "وصول المقاول",
    "contractorAccessHint": "يعرض الرابط للشركة بطاقاتها الخاصة في هذا المشروع فقط — دون حساب. ينتهي بعد 30 يومًا ويمكن سحبه في أي وقت.",
    "pickContractor": "اختر شركة",
    "createLink": "إنشاء رابط",
    "linkCreated": "تم إنشاء الرابط ونسخه.",
    "linkCreateFailed": "تعذّر إنشاء الرابط.",
    "linkRevoked": "تم سحب الرابط.",
    "linkRevokeFailed": "فشل السحب.",
    "linkCopied": "تم نسخ الرابط.",
    "copyLink": "نسخ الرابط",
    "revokeLink": "سحب الرابط",
    "linkLive": "نشط",
    "linkExpired": "منتهٍ",
    "linkRevokedBadge": "مسحوب",
    "linkExpiresAt": "صالح حتى {date}",
    "linkRevokedAt": "سُحب في {date}",
    "noLinksYet": "لم يتم إصدار رابط بعد.",
    "noContractorsInProject": "لا يوجد مقاولون مرتبطون بهذا المشروع بعد.",
    "moveFailed": "تعذّر نقل البطاقة.",
    "saveFailed": "تعذّر الحفظ.",
    "deleteFailed": "فشل الحذف.",
    "loadFailed": "تعذّر تحميل اللوحة",
    "loadFailedHint": "يرجى إعادة تحميل الصفحة. إذا استمر الأمر، أبلغنا.",
    "retry": "إعادة التحميل",
    "archiveNotEmpty": "{count, plural, zero {لا توجد بطاقات في القائمة.} one {ما زالت هناك بطاقة واحدة في القائمة — يرجى إفراغها أولاً.} two {ما زالت هناك بطاقتان في القائمة — يرجى إفراغها أولاً.} few {ما زالت هناك # بطاقات في القائمة — يرجى إفراغها أولاً.} many {ما زالت هناك # بطاقة في القائمة — يرجى إفراغها أولاً.} other {ما زالت هناك # بطاقة في القائمة — يرجى إفراغها أولاً.}}",
    "dragList": "نقل القائمة «{name}»",
    "movedToEnd": "كان الترتيب متضاربًا — تم وضعها في النهاية.",
    "assigneeUnknown": "مُسند (غير معروف)",
    "unknownContractor": "شركة غير معروفة",
    "linkCopyFailed": "تعذّر النسخ — يرجى تحديد الرابط يدويًا.",
    "confirmArchiveList": "هل تريد أرشفة القائمة \"{name}\"؟",
    "listArchived": "تمت أرشفة القائمة.",
    "listRestored": "تمت استعادة القائمة.",
    "restoreList": "استعادة",
    "archivedLists": "{count, plural, zero {# قوائم مؤرشفة} one {قائمة مؤرشفة واحدة} two {قائمتان مؤرشفتان} few {# قوائم مؤرشفة} many {# قائمة مؤرشفة} other {# قائمة مؤرشفة}}",
    "archivedCardCount": "{count, plural, zero {# بطاقات بداخلها} one {بطاقة واحدة بداخلها} two {بطاقتان بداخلها} few {# بطاقات بداخلها} many {# بطاقة بداخلها} other {# بطاقة بداخلها}}",
    "discardChanges": "ستفقد التغييرات غير المحفوظة على العنوان أو الوصف أو تاريخ الاستحقاق.",
    "confirmRevoke": "إلغاء وصول \"{name}\"؟ سيتوقف الرابط فورًا، وسيكون للرابط الجديد عنوان مختلف.",
    "addCardFailed": "تعذّر إنشاء البطاقة.",
    "addListFailed": "تعذّر إنشاء القائمة.",
    "renameFailed": "فشلت إعادة التسمية.",
    "archiveFailed": "فشلت الأرشفة.",
    "restoreFailed": "فشلت الاستعادة.",
    "discardConfirm": "تجاهل",
    "keepEditing": "متابعة التحرير",
    "archivedListsFailed": "تعذّر تحميل القوائم المؤرشفة. اللوحة نفسها غير متأثرة.",
    "revokeConfirm": "إلغاء الوصول"
  },
  "boardLink": {
    "invalidTitle": "لم يعد هذا الرابط صالحًا",
    "invalidBody": "انتهت صلاحيته أو تم سحبه. يرجى طلب رابط جديد من جهة الاتصال لديك.",
    "errorTitle": "حدث خطأ ما",
    "errorBody": "يرجى إعادة تحميل الصفحة. إذا استمر الأمر، تواصل مع من أرسل لك الرابط.",
    "openCount": "{count, plural, zero {لا توجد مهام مفتوحة} one {مهمة مفتوحة واحدة} two {مهمتان مفتوحتان} few {# مهام مفتوحة} many {# مهمة مفتوحة} other {# مهمة مفتوحة}}",
    "doneHeading": "تم",
    "none": "لا توجد مهام مسندة إليك حاليًا.",
    "due": "الموعد النهائي: {date}",
    "overdue": "متأخرة",
    "footer": "مُقدَّم عبر ZeroSnag",
    "sentBy": "أُرسل بواسطة {sender}"
  }
}
